// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { Diagram_NodeFragment, Diagram_EdgeFragment } from '../../../../components/diagrams/Diagram.generated';
import { GetWaterfallSummary_GrowthProfileFragment, GetWaterfallSummary_EstateWaterfallFragment, GetWaterfallSummary_EstateWaterfallVizFragment } from '../../../estateWaterfall/graphql/GetWaterfallSummary.generated';
import { GrowthProfiles_GrowthProfileFragment } from '../../../estateWaterfall/graphql/GrowthProfiles.generated';
import { EstateWaterfallAssumptionsSlide_GrowthProfileFragment, EstateWaterfallAssumptionsSlide_EstateWaterfallVizFragment, EstateWaterfallAssumptionsSlide_CashflowFragment, EstateWaterfallAssumptionsSlide_LiabilityFragment } from '../components/slides/estateWaterfall/Assumptions/graphql/EstateWaterfallAssumptionsSlide.generated';
import { HypotheticalTransfersSummaryQuery_EstateWaterfallVizNodeFragment, HypotheticalTransfersSummaryQuery_EstateWaterfallLoanFragment, HypotheticalTransfersSummaryQuery_EstateWaterfallTransferFragment, HypotheticalTransfersSummary_EstateWaterfallHypotheticalTransferFragment, HypotheticalTransfersSummary_HypotheticalSaleLoanFragment, HypotheticalTransfersSummary_HypotheticalGratFragment, HypotheticalTransfersSummary_HypotheticalCrtFragment, HypotheticalTransfersSummary_HypotheticalCltFragment, HypotheticalTransfersSummary_HypotheticalInsuranceFragment } from '../../../summaryPanels/HypotheticalTransfersSummaryPanel/graphql/HypotheticalTransfersSummary.generated';
import { EstateWaterfall_EstateWaterfallVizFragment, EstateWaterfall_NodeFragment, EstateWaterfall_EstateWaterfallHypotheticalTransferFragment } from '../../../estateWaterfall/graphql/EstateWaterfall.generated';
import { EstateWaterfallDiagramSlide_EstateWaterfallFragment } from '../components/slides/estateWaterfall/Diagram/graphql/EstateWaterfallDiagramSlide.generated';
import { EstateWaterfallComparisonTrowser_EstateWaterfallFragment, EstateWaterfallComparisonTrowser_EstateWaterfallVizFragment } from '../../../estateWaterfall/components/EstateWaterfallComparisionTrowser/graphql/EstateWaterfallComparisonTrowser.generated';
import { GraphViz_ViewFragment, GraphViz_MinimalViewFragment } from '../../../graphViz/graphql/GraphVizView.generated';
import { ClientPresentation_BeneficiaryReport_EstateWaterfallFragment, ClientPresentation_BeneficiaryReport_EstateWaterfallBeneficiaryReportFragment } from '../components/slides/BeneficiaryReport/graphql/ClientPresentation.BeneficiaryReport.generated';
import { EntityPresentation_EntityFragment } from '../../entities/graphql/EntityPresentation.generated';
import { PresentationViewSource_EntityFragment, PresentationViewSource_ClientProfileFragment, PresentationViewSource_ClientOrganizationFragment, PresentationViewSource_TestamentaryEntityFragment } from '../components/presentationEntityActions/graphql/PresentationViewSource.generated';
import { AllEntitiesSlide_EntityFragment } from '../components/slides/AllEntities/graphql/AllEntitiesSlide.generated';
import { CoverSlide_PresentationBundleFragment } from '../components/slides/CoverSlide/CoverSlide.generated';
import { CustomSlide_PresentationBundleFragment } from '../components/slides/CustomSlide/CustomSlide.generated';
import { WaterfallOverviewBundleSettingsModal_EstateWaterfallFragment } from '../components/settingsModals/graphql/WaterfallOverviewBundleSettingsModal.generated';
import { EstateTaxScenarios_EstateTaxScenarioFragment } from '../../../estateTaxScenarios/graphql/EstateTaxScenarios.generated';
import { LifetimeExemptionCard_ClientProfileFragment } from '../../../gifting/LifetimeExemptionCard/graphql/LifetimeExemptionCard.generated';
import { EntityMap_HouseholdFragment } from '../../../entityMap/graphql/EntityMap.generated';
import { ProfessionalTeamSlide_ClientProfileFragment, ProfessionalTeamSlide_ClientOrganizationFragment } from '../components/slides/ProfessionalTeamSlide/graphql/ProfessionalTeamSlide.generated';
import { TenantPresentationConfiguration_HouseholdFragment, TenantPresentationConfiguration_TenantDisclaimerConfigurationFragment } from '../../graphql/TenantPresentationConfiguration.generated';
import { BalanceSheetTable_BalanceSheetFragment } from '../../../balanceSheet/BalanceSheetTable/graphql/BalanceSheetTable.fragments.generated';
import { GrowthProfileModal_AssetClassFragment } from '../../../growthProfiles/GrowthProfileModal/graphql/GrowthProfileModal.generated';
import { HouseholdMissingDocumentFragment, ClientProfile_MissingDocumentFragment } from '../../../missingDocuments/graphql/MissingDocuments.generated';
import { gql } from '@apollo/client';
import { Diagram_NodeFragmentDoc, Diagram_EdgeFragmentDoc } from '../../../../components/diagrams/Diagram.generated';
import { GetWaterfallSummary_GrowthProfileFragmentDoc, GetWaterfallSummary_EstateWaterfallFragmentDoc, GetWaterfallSummary_EstateWaterfallVizFragmentDoc } from '../../../estateWaterfall/graphql/GetWaterfallSummary.generated';
import { GrowthProfiles_GrowthProfileFragmentDoc } from '../../../estateWaterfall/graphql/GrowthProfiles.generated';
import { EstateWaterfallAssumptionsSlide_GrowthProfileFragmentDoc, EstateWaterfallAssumptionsSlide_EstateWaterfallVizFragmentDoc, EstateWaterfallAssumptionsSlide_CashflowFragmentDoc, EstateWaterfallAssumptionsSlide_LiabilityFragmentDoc } from '../components/slides/estateWaterfall/Assumptions/graphql/EstateWaterfallAssumptionsSlide.generated';
import { HypotheticalTransfersSummaryQuery_EstateWaterfallVizNodeFragmentDoc, HypotheticalTransfersSummaryQuery_EstateWaterfallLoanFragmentDoc, HypotheticalTransfersSummaryQuery_EstateWaterfallTransferFragmentDoc, HypotheticalTransfersSummary_EstateWaterfallHypotheticalTransferFragmentDoc, HypotheticalTransfersSummary_HypotheticalSaleLoanFragmentDoc, HypotheticalTransfersSummary_HypotheticalGratFragmentDoc, HypotheticalTransfersSummary_HypotheticalCrtFragmentDoc, HypotheticalTransfersSummary_HypotheticalCltFragmentDoc, HypotheticalTransfersSummary_HypotheticalInsuranceFragmentDoc } from '../../../summaryPanels/HypotheticalTransfersSummaryPanel/graphql/HypotheticalTransfersSummary.generated';
import { EstateWaterfall_EstateWaterfallVizFragmentDoc, EstateWaterfall_NodeFragmentDoc, EstateWaterfall_EstateWaterfallHypotheticalTransferFragmentDoc } from '../../../estateWaterfall/graphql/EstateWaterfall.generated';
import { EstateWaterfallDiagramSlide_EstateWaterfallFragmentDoc } from '../components/slides/estateWaterfall/Diagram/graphql/EstateWaterfallDiagramSlide.generated';
import { EstateWaterfallComparisonTrowser_EstateWaterfallFragmentDoc, EstateWaterfallComparisonTrowser_EstateWaterfallVizFragmentDoc } from '../../../estateWaterfall/components/EstateWaterfallComparisionTrowser/graphql/EstateWaterfallComparisonTrowser.generated';
import { GraphViz_ViewFragmentDoc, GraphViz_MinimalViewFragmentDoc } from '../../../graphViz/graphql/GraphVizView.generated';
import { ClientPresentation_BeneficiaryReport_EstateWaterfallFragmentDoc, ClientPresentation_BeneficiaryReport_EstateWaterfallBeneficiaryReportFragmentDoc } from '../components/slides/BeneficiaryReport/graphql/ClientPresentation.BeneficiaryReport.generated';
import { EntityPresentation_EntityFragmentDoc } from '../../entities/graphql/EntityPresentation.generated';
import { PresentationViewSource_EntityFragmentDoc, PresentationViewSource_ClientProfileFragmentDoc, PresentationViewSource_ClientOrganizationFragmentDoc, PresentationViewSource_TestamentaryEntityFragmentDoc } from '../components/presentationEntityActions/graphql/PresentationViewSource.generated';
import { AllEntitiesSlide_EntityFragmentDoc } from '../components/slides/AllEntities/graphql/AllEntitiesSlide.generated';
import { CoverSlide_PresentationBundleFragmentDoc } from '../components/slides/CoverSlide/CoverSlide.generated';
import { CustomSlide_PresentationBundleFragmentDoc } from '../components/slides/CustomSlide/CustomSlide.generated';
import { WaterfallOverviewBundleSettingsModal_EstateWaterfallFragmentDoc } from '../components/settingsModals/graphql/WaterfallOverviewBundleSettingsModal.generated';
import { EstateTaxScenarios_EstateTaxScenarioFragmentDoc } from '../../../estateTaxScenarios/graphql/EstateTaxScenarios.generated';
import { LifetimeExemptionCard_ClientProfileFragmentDoc } from '../../../gifting/LifetimeExemptionCard/graphql/LifetimeExemptionCard.generated';
import { EntityMap_HouseholdFragmentDoc } from '../../../entityMap/graphql/EntityMap.generated';
import { ProfessionalTeamSlide_ClientProfileFragmentDoc, ProfessionalTeamSlide_ClientOrganizationFragmentDoc } from '../components/slides/ProfessionalTeamSlide/graphql/ProfessionalTeamSlide.generated';
import { TenantPresentationConfiguration_HouseholdFragmentDoc, TenantPresentationConfiguration_TenantDisclaimerConfigurationFragmentDoc } from '../../graphql/TenantPresentationConfiguration.generated';
import { BalanceSheetTable_BalanceSheetFragmentDoc } from '../../../balanceSheet/BalanceSheetTable/graphql/BalanceSheetTable.fragments.generated';
import { GrowthProfileModal_AssetClassFragmentDoc } from '../../../growthProfiles/GrowthProfileModal/graphql/GrowthProfileModal.generated';
import { HouseholdMissingDocumentFragmentDoc, ClientProfile_MissingDocumentFragmentDoc } from '../../../missingDocuments/graphql/MissingDocuments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClientPresentationDesignerV2_DocumentSummaryPageFragment = { __typename?: 'DocumentSummaryPage', id: string, documentType?: Types.PresentationDocumentType | null, relevantClientProfiles: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: { __typename?: 'ClientProfile', id: string, displayName: string } | null } | null> | null }, summary?: { __typename?: 'DocumentSummary', id: string, displayName: string, summary: string, summaryFormat?: Types.DocumentSummarySummaryFormat | null, documentv2: { __typename?: 'Document', id: string, name: string } } | null };

export type ClientPresentationDesignerV2_PresentationPageFragment = { __typename?: 'PresentationPage', id: string, kind: Types.PresentationPageKind, customPage?: { __typename?: 'PresentationCustomPage', id: string, pageName: string, pageContent: string, customPrompt?: string | null } | null, coverPage?: { __typename?: 'PresentationCoverPage', id: string, customContent?: string | null, displayTitle?: string | null, customPrompt?: string | null } | null, presentationBundleCoverPage?: { __typename?: 'PresentationBundleCoverPage', id: string, content: string } | null, waterfallBundleCoverPage?: { __typename?: 'WaterfallBundleCoverPage', id: string, content: string } | null, documentSummaryPage?: (
    { __typename?: 'DocumentSummaryPage', id: string }
    & ClientPresentationDesignerV2_DocumentSummaryPageFragment
  ) | null, beneficiaryPage?: { __typename?: 'BeneficiaryPage', id: string, beneficiaryID: string } | null, diagramPage?: { __typename?: 'PresentationDiagramPage', id: string, pageName: string, customPrompt?: string | null, nodeConfigurations: Array<(
      { __typename?: 'PresentationDiagramNodeConfiguration', semanticGroup: string, notes?: string | null, entityNodeID?: string | null, phase?: number | null, xPosition?: number | null, yPosition?: number | null, width?: number | null, height?: number | null }
      & Diagram_NodeFragment
    )>, edgeDefinitions: Array<(
      { __typename?: 'PresentationDiagramEdgeDefinition', sourceHandle?: string | null, targetHandle?: string | null, conditional?: boolean | null }
      & Diagram_EdgeFragment
    )>, phases?: { __typename?: 'PresentationDiagramPhases', bands: Array<{ __typename?: 'PresentationDiagramPhaseBand', label: string, belowPhaseIndex: number }> } | null } | null, balanceSheetBundleConfiguration?: (
    { __typename?: 'BalanceSheetBundleConfiguration' }
    & ClientPresentationDesignerV2_BalanceSheetBundleConfigurationFragment
  ) | null };

export type ClientPresentationDesignerV2_GrowthProfileFragment = (
  { __typename?: 'GrowthProfile', id: string, displayName: string }
  & GetWaterfallSummary_GrowthProfileFragment
  & GrowthProfiles_GrowthProfileFragment
  & EstateWaterfallAssumptionsSlide_GrowthProfileFragment
);

export type ClientPresentationDesignerV2_EstateWaterfallFragment = (
  { __typename?: 'EstateWaterfall', id: string, displayName: string, household: { __typename?: 'Household', id: string, displayName: string }, filter?: { __typename?: 'EstateWaterfallVisualizationFilter', id: string, includedClients: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: { __typename?: 'ClientProfile', id: string } | null } | null> | null }, includedEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string } | null } | null> | null } } | null, visualization: (
    { __typename?: 'EstateWaterfallViz', _cacheKey: string, nodes: Array<(
      { __typename?: 'EstateWaterfallVizNode' }
      & HypotheticalTransfersSummaryQuery_EstateWaterfallVizNodeFragment
    )>, loans: Array<(
      { __typename?: 'EstateWaterfallLoan' }
      & HypotheticalTransfersSummaryQuery_EstateWaterfallLoanFragment
    )>, transferLog: Array<(
      { __typename?: 'EstateWaterfallTransfer' }
      & HypotheticalTransfersSummaryQuery_EstateWaterfallTransferFragment
    )> }
    & EstateWaterfall_EstateWaterfallVizFragment
  ), visualizationWithProjections: (
    { __typename?: 'EstateWaterfallViz' }
    & ClientPresentationDesignerV2_EstateWaterfallVizFragment
  ), nonHypotheticalVisualizationWithProjections: (
    { __typename?: 'EstateWaterfallViz' }
    & ClientPresentationDesignerV2_EstateWaterfallVizFragment
  ), hypotheticalTransfers: { __typename?: 'EstateWaterfallHypotheticalTransferConnection', edges?: Array<{ __typename?: 'EstateWaterfallHypotheticalTransferEdge', node?: (
        { __typename?: 'EstateWaterfallHypotheticalTransfer' }
        & HypotheticalTransfersSummary_EstateWaterfallHypotheticalTransferFragment
        & EstateWaterfall_EstateWaterfallHypotheticalTransferFragment
      ) | null } | null> | null }, hypotheticalSaleLoans: { __typename?: 'HypotheticalSaleLoanConnection', edges?: Array<{ __typename?: 'HypotheticalSaleLoanEdge', node?: (
        { __typename?: 'HypotheticalSaleLoan' }
        & HypotheticalTransfersSummary_HypotheticalSaleLoanFragment
      ) | null } | null> | null }, hypotheticalGrats: { __typename?: 'HypotheticalGRATConnection', edges?: Array<{ __typename?: 'HypotheticalGRATEdge', node?: (
        { __typename?: 'HypotheticalGRAT' }
        & HypotheticalTransfersSummary_HypotheticalGratFragment
      ) | null } | null> | null }, hypotheticalCrts: { __typename?: 'HypotheticalCRTConnection', edges?: Array<{ __typename?: 'HypotheticalCRTEdge', node?: (
        { __typename?: 'HypotheticalCRT' }
        & HypotheticalTransfersSummary_HypotheticalCrtFragment
      ) | null } | null> | null }, hypotheticalClts: { __typename?: 'HypotheticalCLTConnection', edges?: Array<{ __typename?: 'HypotheticalCLTEdge', node?: (
        { __typename?: 'HypotheticalCLT' }
        & HypotheticalTransfersSummary_HypotheticalCltFragment
      ) | null } | null> | null }, hypotheticalInsurance: { __typename?: 'HypotheticalInsuranceConnection', edges?: Array<{ __typename?: 'HypotheticalInsuranceEdge', node?: (
        { __typename?: 'HypotheticalInsurance' }
        & HypotheticalTransfersSummary_HypotheticalInsuranceFragment
      ) | null } | null> | null } }
  & GetWaterfallSummary_EstateWaterfallFragment
  & EstateWaterfallDiagramSlide_EstateWaterfallFragment
);

export type ClientPresentationDesignerV2_EstateWaterfallVizFragment = (
  { __typename?: 'EstateWaterfallViz', _cacheKey: string, materializedInputParams: { __typename: 'EstateWaterfallMaterializedInputParams', firstGrantorDeathYear: number, secondGrantorDeathYear?: number | null, selectedGrowthProfile?: (
      { __typename?: 'GrowthProfile' }
      & ClientPresentationDesignerV2_GrowthProfileFragment
    ) | null }, nodes: Array<(
    { __typename?: 'EstateWaterfallVizNode' }
    & EstateWaterfall_NodeFragment
  )> }
  & GetWaterfallSummary_EstateWaterfallVizFragment
  & EstateWaterfallAssumptionsSlide_EstateWaterfallVizFragment
  & EstateWaterfall_EstateWaterfallVizFragment
);

export type ClientPresentationDesignerV2_WaterfallBundleConfigurationFragment = { __typename?: 'WaterfallBundleConfiguration', id: string, displayName?: string | null, includeCoverPage: boolean, includeAssumptionsPage: boolean, includeDiagramPage: boolean, includeSummaryPage: boolean, includeSummaryBars?: boolean | null, includeSummaryTiles?: boolean | null, showSummaryTileDetails: boolean, useUpdatedSummaryPage: boolean, includeOverview: boolean, includeBeforeFirstDeath: boolean, includeAfterFirstDeath: boolean, includeAfterSecondDeath: boolean, summaryHideZeroDollarItems: boolean, includeTaxOverviewPage: boolean, firstDeathYear?: number | null, secondDeathYear?: number | null, growthProfile?: (
    { __typename?: 'GrowthProfile' }
    & ClientPresentationDesignerV2_GrowthProfileFragment
  ) | null, estateWaterfall?: (
    { __typename?: 'EstateWaterfall' }
    & ClientPresentationDesignerV2_EstateWaterfallFragment
  ) | null, estateWaterfallViz?: (
    { __typename?: 'EstateWaterfallViz' }
    & ClientPresentationDesignerV2_EstateWaterfallVizFragment
  ) | null, estateWaterfallVizNonHypothetical?: (
    { __typename?: 'EstateWaterfallViz' }
    & ClientPresentationDesignerV2_EstateWaterfallVizFragment
  ) | null };

export type ClientPresentationDesignerV2_ComparedWaterfall_EstateWaterfallFragment = (
  { __typename?: 'EstateWaterfall', id: string, visualizationWithProjections: (
    { __typename?: 'EstateWaterfallViz' }
    & ClientPresentationDesignerV2_EstateWaterfallVizFragment
    & EstateWaterfallComparisonTrowser_EstateWaterfallVizFragment
  ) }
  & ClientPresentationDesignerV2_EstateWaterfallFragment
  & EstateWaterfallComparisonTrowser_EstateWaterfallFragment
);

export type ClientPresentationDesignerV2_ComparedWaterfallFragment = { __typename?: 'ComparedWaterfall', id: string, displayName: string, firstDeathYear?: number | null, secondDeathYear?: number | null, growthProfile?: { __typename?: 'GrowthProfile', id: string } | null, estateWaterfall?: (
    { __typename?: 'EstateWaterfall', id: string }
    & ClientPresentationDesignerV2_ComparedWaterfall_EstateWaterfallFragment
  ) | null, estateWaterfallViz: (
    { __typename?: 'EstateWaterfallViz' }
    & ClientPresentationDesignerV2_EstateWaterfallVizFragment
    & EstateWaterfallComparisonTrowser_EstateWaterfallVizFragment
  ) };

export type ClientPresentationDesignerV2_WaterfallComparisonBundleConfigurationFragment = { __typename?: 'WaterfallComparisonBundleConfiguration', id: string, displayName: string, includeAssumptionsPage: boolean, includeCoverPage: boolean, comparedWaterfalls?: Array<(
    { __typename?: 'ComparedWaterfall' }
    & ClientPresentationDesignerV2_ComparedWaterfallFragment
  )> | null };

export type ClientPresentationDesignerV2_EstateInsightsBundleConfigurationFragment = { __typename?: 'EstateInsightsBundleConfiguration', id: string, includeMissingDocumentsPage: boolean, estateInsights?: Array<(
    { __typename?: 'EstateInsight' }
    & ClientPresentationDesignerV2_EstateInsightFragment
  )> | null };

export type ClientPresentationDesignerV2_EntityGraphViewBundleConfigurationFragment = { __typename?: 'EntityGraphViewBundleConfiguration', id: string, displayName?: string | null, entityGraphView?: (
    { __typename?: 'EntityGraphView', id: string }
    & GraphViz_ViewFragment
  ) | null };

export type ClientPresentationDesignerV2_BeneficiariesBundleConfigurationFragment = { __typename?: 'BeneficiariesBundleConfiguration', id: string, displayName?: string | null, includeHouseholdOverview: boolean, includeIndividualOverviews: boolean, includeDetailedBreakdownsInIndividualOverviews: boolean, firstDeathYear?: number | null, secondDeathYear?: number | null, growthProfile?: (
    { __typename?: 'GrowthProfile' }
    & ClientPresentationDesignerV2_GrowthProfileFragment
  ) | null, estateWaterfall?: (
    { __typename?: 'EstateWaterfall' }
    & ClientPresentation_BeneficiaryReport_EstateWaterfallFragment
  ) | null, estateWaterfallBeneficiaryReport?: (
    { __typename?: 'EstateWaterfallBeneficiaryReport' }
    & ClientPresentation_BeneficiaryReport_EstateWaterfallBeneficiaryReportFragment
  ) | null, householdOverviewProfiles?: Array<{ __typename?: 'ClientProfile', id: string, displayName: string }> | null, householdOverviewOrganizations?: Array<{ __typename?: 'ClientOrganization', id: string, name: string }> | null, individualOverviewProfiles?: Array<{ __typename?: 'ClientProfile', id: string, displayName: string }> | null, individualOverviewOrganizations?: Array<{ __typename?: 'ClientOrganization', id: string, name: string }> | null };

export type ClientPresentationDesignerV2_EntityFragment = (
  { __typename?: 'Entity', id: string }
  & EntityPresentation_EntityFragment
  & PresentationViewSource_EntityFragment
);

export type ClientPresentationDesignerV2_EntitySummaryBundleConfigurationFragment = { __typename?: 'EntitySummaryBundleConfiguration', id: string, includeEntitySummaryPage: boolean, includeDiagramAndNotesPage: boolean, includeBalanceSheetPage: boolean, includeBalanceSheetExportPage: boolean, includeBeneficiariesAndDispositionsPage: boolean, includeInsurancePolicySlides: boolean, includeEntityNotesOnSummaryPage: boolean, entity: (
    { __typename?: 'Entity', id: string }
    & ClientPresentationDesignerV2_EntityFragment
  ), deathOrder: { __typename?: 'ClientProfile', id: string, displayName: string } };

export type ClientPresentationDesignerV2_PresentationCustomPageBundleConfigurationFragment = { __typename?: 'PresentationCustomPageBundleConfiguration', id: string, pageHeader?: string | null, pageSubheader?: string | null, includePageHeader: boolean };

export type ClientPresentationDesignerV2_EntitiesOverviewBundleConfigurationEntityFragment = { __typename?: 'EntitiesOverviewBundleConfigurationEntity', id: string, index: number, isHidden: boolean, entity: (
    { __typename?: 'Entity', id: string }
    & AllEntitiesSlide_EntityFragment
  ) };

export type ClientPresentationDesignerV2_EntitiesOverviewBundleConfigurationFragment = { __typename?: 'EntitiesOverviewBundleConfiguration', id: string, displayName?: string | null, showSummaryMetrics: boolean, household: { __typename?: 'Household', id: string }, householdMetrics?: (
    { __typename?: 'HouseholdMetrics' }
    & ClientPresentationDesignerV2_HouseholdMetricsFragment
  ) | null, entities: { __typename?: 'EntitiesOverviewBundleConfigurationEntityConnection', edges?: Array<{ __typename?: 'EntitiesOverviewBundleConfigurationEntityEdge', node?: (
        { __typename?: 'EntitiesOverviewBundleConfigurationEntity' }
        & ClientPresentationDesignerV2_EntitiesOverviewBundleConfigurationEntityFragment
      ) | null } | null> | null } };

export type ClientPresentationDesignerV2_PresentationBundleFragment = (
  { __typename?: 'PresentationBundle', id: string, index: number, kind: Types.PresentationBundleKind, templateNotes?: string | null, excludeFromOutput: boolean, pages: { __typename?: 'PresentationPageConnection', edges?: Array<{ __typename?: 'PresentationPageEdge', node?: (
        { __typename?: 'PresentationPage' }
        & ClientPresentationDesignerV2_PresentationPageFragment
      ) | null } | null> | null }, waterfallBundleConfiguration?: (
    { __typename?: 'WaterfallBundleConfiguration' }
    & ClientPresentationDesignerV2_WaterfallBundleConfigurationFragment
  ) | null, entitySummaryBundleConfiguration?: (
    { __typename?: 'EntitySummaryBundleConfiguration' }
    & ClientPresentationDesignerV2_EntitySummaryBundleConfigurationFragment
  ) | null, customPageBundleConfiguration?: (
    { __typename?: 'PresentationCustomPageBundleConfiguration' }
    & ClientPresentationDesignerV2_PresentationCustomPageBundleConfigurationFragment
  ) | null, waterfallComparisonBundleConfiguration?: (
    { __typename?: 'WaterfallComparisonBundleConfiguration' }
    & ClientPresentationDesignerV2_WaterfallComparisonBundleConfigurationFragment
  ) | null, estateInsightsBundleConfiguration?: (
    { __typename?: 'EstateInsightsBundleConfiguration' }
    & ClientPresentationDesignerV2_EstateInsightsBundleConfigurationFragment
  ) | null, entityGraphViewBundleConfiguration?: (
    { __typename?: 'EntityGraphViewBundleConfiguration' }
    & ClientPresentationDesignerV2_EntityGraphViewBundleConfigurationFragment
  ) | null, entitiesOverviewBundleConfiguration?: (
    { __typename?: 'EntitiesOverviewBundleConfiguration' }
    & ClientPresentationDesignerV2_EntitiesOverviewBundleConfigurationFragment
  ) | null, beneficiariesBundleConfiguration?: (
    { __typename?: 'BeneficiariesBundleConfiguration' }
    & ClientPresentationDesignerV2_BeneficiariesBundleConfigurationFragment
  ) | null, dividerBundleConfiguration?: (
    { __typename?: 'DividerBundleConfiguration' }
    & ClientPresentationDesignerV2_DividerBundleConfigurationFragment
  ) | null, balanceSheetBundleConfiguration?: (
    { __typename?: 'BalanceSheetBundleConfiguration' }
    & ClientPresentationDesignerV2_BalanceSheetBundleConfigurationFragment
  ) | null, documentsReviewedBundleConfiguration?: (
    { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' }
    & ClientPresentationDesignerV2_DocumentsReviewedBundleConfigurationFragment
  ) | null, trustOverviewBundleConfiguration?: (
    { __typename?: 'PresentationTrustOverviewBundleConfiguration' }
    & ClientPresentationDesignerV2_TrustOverviewBundleConfigurationFragment
  ) | null, businessOverviewBundleConfiguration?: (
    { __typename?: 'PresentationBusinessOverviewBundleConfiguration' }
    & ClientPresentationDesignerV2_BusinessOverviewBundleConfigurationFragment
  ) | null, familyOverviewBundleConfiguration?: (
    { __typename?: 'PresentationFamilyOverviewBundleConfiguration' }
    & ClientPresentationDesignerV2_FamilyOverviewBundleConfigurationFragment
  ) | null, willBundleConfiguration?: (
    { __typename?: 'PresentationWillBundleConfiguration' }
    & ClientPresentationDesignerV2_WillBundleConfigurationFragment
  ) | null, powerOfAttorneyBundleConfiguration?: (
    { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' }
    & ClientPresentationDesignerV2_PowerOfAttorneyBundleConfigurationFragment
  ) | null, healthcareDirectiveBundleConfiguration?: (
    { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' }
    & ClientPresentationDesignerV2_HealthcareDirectiveBundleConfigurationFragment
  ) | null, assetDistributionBundleConfiguration?: (
    { __typename?: 'PresentationAssetDistributionBundleConfiguration' }
    & ClientPresentationDesignerV2_AssetDistributionBundleConfigurationFragment
  ) | null, planningOpportunitiesBundleConfiguration?: (
    { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' }
    & ClientPresentationDesignerV2_PlanningOpportunitiesBundleConfigurationFragment
  ) | null }
  & CoverSlide_PresentationBundleFragment
  & CustomSlide_PresentationBundleFragment
);

export type ClientPresentationDesignerV2_DividerBundleConfigurationFragment = { __typename?: 'DividerBundleConfiguration', id: string, dividerTitle?: string | null, customContent?: string | null };

export type ClientPresentationDesignerV2_DocumentsReviewedBundleConfigurationFragment = { __typename?: 'PresentationDocumentsReviewedBundleConfiguration', id: string, displayName?: string | null, reviewedDocuments: { __typename?: 'PresentationDocumentsReviewedDocumentConnection', edges?: Array<{ __typename?: 'PresentationDocumentsReviewedDocumentEdge', node?: { __typename?: 'PresentationDocumentsReviewedDocument', id: string, documentName: string, dateDisplay: string, sortOrder: number } | null } | null> | null } };

export type ClientPresentationDesignerV2_ItemCitationFragment = { __typename?: 'PresentationItemCitation', id: string, document: { __typename?: 'Document', id: string }, fileParagraphs?: Array<{ __typename?: 'FileParagraph', id: string, boundingRegions: Array<{ __typename?: 'BoundingRegion', PageNumber: number, Polygon: Array<{ __typename?: 'Coordinate', x: number, y: number }> }>, file?: { __typename?: 'File', id: string, pdfDocument?: { __typename?: 'Document', id: string } | null } | null }> | null };

export type ClientPresentationDesignerV2_TrustOverviewBundleConfigurationFragment = { __typename?: 'PresentationTrustOverviewBundleConfiguration', id: string, displayName?: string | null, itemsPerPage: number, trusts: { __typename?: 'PresentationTrustOverviewTrustConfigurationConnection', edges?: Array<{ __typename?: 'PresentationTrustOverviewTrustConfigurationEdge', node?: { __typename?: 'PresentationTrustOverviewTrustConfiguration', id: string, displayName: string, sortOrder: number, trustItems: { __typename?: 'PresentationTrustOverviewItemConnection', edges?: Array<{ __typename?: 'PresentationTrustOverviewItemEdge', node?: { __typename?: 'PresentationTrustOverviewItem', id: string, label: string, body: string, sortOrder: number, citations?: Array<(
                { __typename?: 'PresentationItemCitation' }
                & ClientPresentationDesignerV2_ItemCitationFragment
              )> | null } | null } | null> | null } } | null } | null> | null } };

export type ClientPresentationDesignerV2_BusinessOverviewBundleConfigurationFragment = { __typename?: 'PresentationBusinessOverviewBundleConfiguration', id: string, displayName?: string | null, itemsPerPage: number, businesses: { __typename?: 'PresentationBusinessOverviewBusinessConfigurationConnection', edges?: Array<{ __typename?: 'PresentationBusinessOverviewBusinessConfigurationEdge', node?: { __typename?: 'PresentationBusinessOverviewBusinessConfiguration', id: string, displayName: string, sortOrder: number, businessItems: { __typename?: 'PresentationBusinessOverviewItemConnection', edges?: Array<{ __typename?: 'PresentationBusinessOverviewItemEdge', node?: { __typename?: 'PresentationBusinessOverviewItem', id: string, label: string, body: string, sortOrder: number, citations?: Array<(
                { __typename?: 'PresentationItemCitation' }
                & ClientPresentationDesignerV2_ItemCitationFragment
              )> | null } | null } | null> | null } } | null } | null> | null } };

export type ClientPresentationDesignerV2_FamilyOverviewBundleConfigurationFragment = { __typename?: 'PresentationFamilyOverviewBundleConfiguration', id: string, displayName?: string | null, members: { __typename?: 'PresentationFamilyOverviewMemberConfigurationConnection', edges?: Array<{ __typename?: 'PresentationFamilyOverviewMemberConfigurationEdge', node?: { __typename?: 'PresentationFamilyOverviewMemberConfiguration', id: string, name: string, relationship: string, description: string, sortOrder: number, citations?: Array<(
          { __typename?: 'PresentationItemCitation' }
          & ClientPresentationDesignerV2_ItemCitationFragment
        )> | null } | null } | null> | null } };

export type ClientPresentationDesignerV2_WillBundleConfigurationFragment = { __typename?: 'PresentationWillBundleConfiguration', id: string, displayName?: string | null, itemsPerPage: number, clients: { __typename?: 'PresentationWillClientConfigurationConnection', edges?: Array<{ __typename?: 'PresentationWillClientConfigurationEdge', node?: { __typename?: 'PresentationWillClientConfiguration', id: string, client: string, sortOrder: number, willItems: { __typename?: 'PresentationWillItemConnection', edges?: Array<{ __typename?: 'PresentationWillItemEdge', node?: { __typename?: 'PresentationWillItem', id: string, label: string, body: string, sortOrder: number, citations?: Array<(
                { __typename?: 'PresentationItemCitation' }
                & ClientPresentationDesignerV2_ItemCitationFragment
              )> | null } | null } | null> | null } } | null } | null> | null } };

export type ClientPresentationDesignerV2_PowerOfAttorneyBundleConfigurationFragment = { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration', id: string, displayName?: string | null, itemsPerPage: number, clients: { __typename?: 'PresentationPowerOfAttorneyClientConfigurationConnection', edges?: Array<{ __typename?: 'PresentationPowerOfAttorneyClientConfigurationEdge', node?: { __typename?: 'PresentationPowerOfAttorneyClientConfiguration', id: string, client: string, sortOrder: number, powerOfAttorneyItems: { __typename?: 'PresentationPowerOfAttorneyItemConnection', edges?: Array<{ __typename?: 'PresentationPowerOfAttorneyItemEdge', node?: { __typename?: 'PresentationPowerOfAttorneyItem', id: string, label: string, body: string, sortOrder: number, citations?: Array<(
                { __typename?: 'PresentationItemCitation' }
                & ClientPresentationDesignerV2_ItemCitationFragment
              )> | null } | null } | null> | null } } | null } | null> | null } };

export type ClientPresentationDesignerV2_HealthcareDirectiveBundleConfigurationFragment = { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration', id: string, displayName?: string | null, itemsPerPage: number, clients: { __typename?: 'PresentationHealthcareDirectiveClientConfigurationConnection', edges?: Array<{ __typename?: 'PresentationHealthcareDirectiveClientConfigurationEdge', node?: { __typename?: 'PresentationHealthcareDirectiveClientConfiguration', id: string, client: string, sortOrder: number, healthcareDirectiveItems: { __typename?: 'PresentationHealthcareDirectiveItemConnection', edges?: Array<{ __typename?: 'PresentationHealthcareDirectiveItemEdge', node?: { __typename?: 'PresentationHealthcareDirectiveItem', id: string, label: string, body: string, sortOrder: number, citations?: Array<(
                { __typename?: 'PresentationItemCitation' }
                & ClientPresentationDesignerV2_ItemCitationFragment
              )> | null } | null } | null> | null } } | null } | null> | null } };

export type ClientPresentationDesignerV2_AssetDistributionBundleConfigurationFragment = { __typename?: 'PresentationAssetDistributionBundleConfiguration', id: string, displayName?: string | null, itemsPerPage: number, deathOrderDisplay: string, description: string, distributionItems: { __typename?: 'PresentationAssetDistributionItemConfigurationConnection', edges?: Array<{ __typename?: 'PresentationAssetDistributionItemConfigurationEdge', node?: { __typename?: 'PresentationAssetDistributionItemConfiguration', id: string, displayName: string, sortOrder: number, itemDetails: { __typename?: 'PresentationAssetDistributionItemDetailConnection', edges?: Array<{ __typename?: 'PresentationAssetDistributionItemDetailEdge', node?: { __typename?: 'PresentationAssetDistributionItemDetail', id: string, label: string, body: string, sortOrder: number, citations?: Array<(
                { __typename?: 'PresentationItemCitation' }
                & ClientPresentationDesignerV2_ItemCitationFragment
              )> | null } | null } | null> | null } } | null } | null> | null } };

export type ClientPresentationDesignerV2_PlanningOpportunitiesBundleConfigurationFragment = { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration', id: string, displayName?: string | null, items: { __typename?: 'PresentationPlanningOpportunitiesItemConnection', edges?: Array<{ __typename?: 'PresentationPlanningOpportunitiesItemEdge', node?: { __typename?: 'PresentationPlanningOpportunitiesItem', id: string, sortOrder: number, opportunityLabel?: string | null, opportunityBody?: string | null, rationaleLabel?: string | null, rationaleBody?: string | null, nextStepLabel?: string | null, nextStepBody?: string | null } | null } | null> | null } };

export type ClientPresentationDesignerV2_BalanceSheetBundleConfigurationFragment = { __typename?: 'BalanceSheetBundleConfiguration', id: string, displayName?: string | null, showInEstate: boolean, separateInEstateDirectlyHeld: boolean, separateInEstateTrusts: boolean, showOutOfEstate: boolean, separateOutOfEstateTrusts: boolean, hideSmallValues: boolean, showSummaryMetrics: boolean, showExpandedAssetCategories: boolean, includeDeathBenefitInTotals: boolean, includeExportSlide: boolean, hiddenColumns: Array<string> };

export type UpdateBalanceSheetBundleConfigurationForPresentationMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateBalanceSheetBundleConfigurationInput;
}>;


export type UpdateBalanceSheetBundleConfigurationForPresentationMutation = { __typename?: 'Mutation', updateBalanceSheetBundleConfiguration: (
    { __typename?: 'BalanceSheetBundleConfiguration' }
    & ClientPresentationDesignerV2_BalanceSheetBundleConfigurationFragment
  ) };

export type ClientPresentationV2_Configuration_ClientPresentationV2Fragment = { __typename?: 'ClientPresentationV2', id: string, showPageNumbers: boolean, showPageNumbersOnCoverSlide: boolean, pageNumberToStartFrom: number, showLegalDisclaimer: boolean, showClientNamesInHeader: boolean };

export type ClientPresentationV2_ClientPresentationV2Fragment = (
  { __typename?: 'ClientPresentationV2', id: string, name: string, reviewRequirement: Types.PresentationApprovalRequirement, approvals: Array<{ __typename?: 'Approval', id: string, kind: Types.ApprovalKind }>, bundles: { __typename?: 'PresentationBundleConnection', edges?: Array<{ __typename?: 'PresentationBundleEdge', node?: (
        { __typename?: 'PresentationBundle' }
        & ClientPresentationDesignerV2_PresentationBundleFragment
      ) | null } | null> | null } }
  & ClientPresentationV2_Configuration_ClientPresentationV2Fragment
);

export type ClientPresentationDesignerV2_EstateWaterfallOptionsFragment = (
  { __typename?: 'EstateWaterfall' }
  & WaterfallOverviewBundleSettingsModal_EstateWaterfallFragment
);

export type ClientPresentationDesignerV2_EntityDocumentRelationshipFragment = { __typename?: 'EntityDocumentRelationship', id: string, document: { __typename?: 'Document', id: string, name: string, type: Types.DocumentType, summaries?: Array<{ __typename?: 'DocumentSummary', id: string, displayName: string }> | null } };

export type ClientPresentationDesignerV2_EntityOptionsFragment = (
  { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string }, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: (
        { __typename?: 'EntityDocumentRelationship' }
        & ClientPresentationDesignerV2_EntityDocumentRelationshipFragment
      ) | null } | null> | null } }
  & PresentationViewSource_EntityFragment
  & AllEntitiesSlide_EntityFragment
);

export type ClientPresentationDesignerV2_DocumentFragment = { __typename?: 'Document', id: string, name: string, type: Types.DocumentType, clientProfile?: { __typename?: 'ClientProfile', id: string } | null, summaries?: Array<{ __typename?: 'DocumentSummary', id: string, displayName: string, updatedAt: Time, sourceDocuments: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', id: string, name: string } | null } | null> | null }, updateUser: { __typename?: 'User', id: string, displayName: string } }> | null, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, entity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string, displayName: string } | null } | null } | null> | null } };

export type ClientPresentationDesignerV2_HouseholdMetricsFragment = { __typename?: 'HouseholdMetrics', totalEstateValue: CurrencyUSD, inEstateValue: CurrencyUSD, outOfEstateValue: CurrencyUSD, outOfEstateCharityValue: CurrencyUSD, outOfEstateFamilyValue: CurrencyUSD };

export type ClientPresentationDesignerV2_HouseholdAssetsSummaryFragment = { __typename?: 'HouseholdAssetsSummary', liquidValue: CurrencyUSD, liquidPercentage: Percent, inEstateLiquidValue: CurrencyUSD, inEstateLiquidPercentage: Percent, outOfEstateLiquidValue: CurrencyUSD, outOfEstateLiquidPercentage: Percent };

export type ClientPresentationDesignerV2_HouseholdFragment = (
  { __typename?: 'Household', id: string, displayName: string, estateValueMetrics: (
    { __typename?: 'HouseholdMetrics' }
    & ClientPresentationDesignerV2_HouseholdMetricsFragment
  ), estateTaxScenarios?: Array<(
    { __typename?: 'EstateTaxScenario', id: string }
    & EstateTaxScenarios_EstateTaxScenarioFragment
  )> | null, possiblePrimaryClients: Array<(
    { __typename?: 'ClientProfile', id: string }
    & LifetimeExemptionCard_ClientProfileFragment
  )>, subBrand?: { __typename?: 'SubBrand', id: string } | null, documents?: Array<(
    { __typename?: 'Document', id: string }
    & ClientPresentationDesignerV2_DocumentFragment
  )> | null }
  & EntityMap_HouseholdFragment
);

export type ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientProfileFragment = (
  { __typename?: 'ClientProfile', id: string }
  & ProfessionalTeamSlide_ClientProfileFragment
);

export type ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientOrganizationFragment = (
  { __typename?: 'ClientOrganization', id: string }
  & ProfessionalTeamSlide_ClientOrganizationFragment
);

export type ClientPresentationDesignerV2_CashflowFragment = (
  { __typename?: 'Cashflow', id: string }
  & EstateWaterfallAssumptionsSlide_CashflowFragment
);

export type ClientPresentationDesignerV2_LiabilityFragment = (
  { __typename?: 'Liability', id: string }
  & EstateWaterfallAssumptionsSlide_LiabilityFragment
);

export type ClientPresentationDesignerV2QueryVariables = Types.Exact<{
  presentationId: Types.Scalars['ID']['input'];
  householdId: Types.Scalars['ID']['input'];
  presentationOnly: Types.Scalars['Boolean']['input'];
  entitiesWhere: Types.EntityWhereInput;
}>;


export type ClientPresentationDesignerV2Query = { __typename?: 'Query', clientPresentationV2s: { __typename?: 'ClientPresentationV2Connection', edges?: Array<{ __typename?: 'ClientPresentationV2Edge', node?: (
        { __typename?: 'ClientPresentationV2' }
        & ClientPresentationV2_ClientPresentationV2Fragment
      ) | null } | null> | null }, households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & ClientPresentationDesignerV2_HouseholdFragment
        & TenantPresentationConfiguration_HouseholdFragment
      ) | null } | null> | null }, householdAssetsSummary: (
    { __typename?: 'HouseholdAssetsSummary' }
    & ClientPresentationDesignerV2_HouseholdAssetsSummaryFragment
  ), estateWaterfalls?: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: (
        { __typename?: 'EstateWaterfall' }
        & ClientPresentationDesignerV2_EstateWaterfallOptionsFragment
      ) | null } | null> | null }, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & ClientPresentationDesignerV2_EntityOptionsFragment
      ) | null } | null> | null }, balanceSheet: (
    { __typename?: 'BalanceSheet' }
    & BalanceSheetTable_BalanceSheetFragment
  ), professionalTeam: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: (
        { __typename?: 'ClientProfile' }
        & ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientProfileFragment
      ) | null } | null> | null }, professionalTeamOrganizations: { __typename?: 'ClientOrganizationConnection', edges?: Array<{ __typename?: 'ClientOrganizationEdge', node?: (
        { __typename?: 'ClientOrganization' }
        & ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientOrganizationFragment
      ) | null } | null> | null }, viewSourceClientProfiles: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: (
        { __typename?: 'ClientProfile' }
        & PresentationViewSource_ClientProfileFragment
      ) | null } | null> | null }, viewSourceClientOrganizations: { __typename?: 'ClientOrganizationConnection', edges?: Array<{ __typename?: 'ClientOrganizationEdge', node?: (
        { __typename?: 'ClientOrganization' }
        & PresentationViewSource_ClientOrganizationFragment
      ) | null } | null> | null }, viewSourceTestamentaryEntities: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: (
        { __typename?: 'TestamentaryEntity' }
        & PresentationViewSource_TestamentaryEntityFragment
      ) | null } | null> | null }, tenantInformation: { __typename?: 'TenantInformation', id: string, disclosuresConfiguration?: (
      { __typename?: 'TenantDisclaimerConfiguration' }
      & TenantPresentationConfiguration_TenantDisclaimerConfigurationFragment
    ) | null }, cashflows: { __typename?: 'CashflowConnection', edges?: Array<{ __typename?: 'CashflowEdge', node?: (
        { __typename?: 'Cashflow', id: string }
        & ClientPresentationDesignerV2_CashflowFragment
      ) | null } | null> | null }, liabilities: { __typename?: 'LiabilityConnection', edges?: Array<{ __typename?: 'LiabilityEdge', node?: (
        { __typename?: 'Liability', id: string }
        & ClientPresentationDesignerV2_LiabilityFragment
      ) | null } | null> | null }, assetClasses: { __typename?: 'AssetClassConnection', edges?: Array<{ __typename?: 'AssetClassEdge', node?: (
        { __typename?: 'AssetClass' }
        & GrowthProfileModal_AssetClassFragment
      ) | null } | null> | null }, estateInsights: { __typename?: 'EstateInsightConnection', edges?: Array<{ __typename?: 'EstateInsightEdge', node?: (
        { __typename?: 'EstateInsight' }
        & ClientPresentationDesignerV2_EstateInsightFragment
      ) | null } | null> | null }, householdMissingDocuments: Array<(
    { __typename?: 'HouseholdMissingDocument' }
    & HouseholdMissingDocumentFragment
  )>, clientProfiles: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: (
        { __typename?: 'ClientProfile' }
        & ClientProfile_MissingDocumentFragment
      ) | null } | null> | null }, householdWorkflowTrackerHistory: { __typename?: 'WorkflowTrackerConnection', edges?: Array<{ __typename?: 'WorkflowTrackerEdge', node?: (
        { __typename?: 'WorkflowTracker' }
        & ClientPresentationDesignerV2_WorkflowTrackerFragment
      ) | null } | null> | null } };

export type ClientPresentationDesignerV2_WorkflowTrackerFragment = { __typename?: 'WorkflowTracker', id: string, status: Types.WorkflowTrackerStatus, kind: Types.WorkflowTrackerKind, description?: string | null, presentation?: { __typename?: 'ClientPresentationV2', id: string } | null };

export type ClientPresentationDesignerV2_EstateInsightFragment = { __typename?: 'EstateInsight', id: string, title: string, summary: string, consideration: string, isCritical: boolean, category: Types.EstateInsightCategory, status: Types.EstateInsightStatus, bucket: Types.EstateInsightBucket, position: number };

export type UpdateClientPresentationV2MutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateClientPresentationV2Input;
}>;


export type UpdateClientPresentationV2Mutation = { __typename?: 'Mutation', updateClientPresentationV2: { __typename?: 'ClientPresentationV2', id: string } };

export type DeleteClientPresentationV2MutationVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  presentationId: Types.Scalars['ID']['input'];
}>;


export type DeleteClientPresentationV2Mutation = { __typename?: 'Mutation', deleteClientPresentationV2?: number | null };

export type DuplicateClientPresentationV2MutationVariables = Types.Exact<{
  presentationId: Types.Scalars['ID']['input'];
}>;


export type DuplicateClientPresentationV2Mutation = { __typename?: 'Mutation', duplicateClientPresentationV2?: { __typename?: 'ClientPresentationV2', id: string } | null };

export type OtherClientPresentationsForHouseholdQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type OtherClientPresentationsForHouseholdQuery = { __typename?: 'Query', clientPresentationV2s: { __typename?: 'ClientPresentationV2Connection', edges?: Array<{ __typename?: 'ClientPresentationV2Edge', node?: { __typename?: 'ClientPresentationV2', id: string, name: string } | null } | null> | null } };

export type AppendBundleToClientPresentationV2MutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateClientPresentationV2Input;
}>;


export type AppendBundleToClientPresentationV2Mutation = { __typename?: 'Mutation', updateClientPresentationV2: { __typename?: 'ClientPresentationV2', id: string } };

export const Operations = {
  Query: {
    ClientPresentationDesignerV2: 'ClientPresentationDesignerV2' as const,
    OtherClientPresentationsForHousehold: 'OtherClientPresentationsForHousehold' as const
  },
  Mutation: {
    UpdateBalanceSheetBundleConfigurationForPresentation: 'UpdateBalanceSheetBundleConfigurationForPresentation' as const,
    UpdateClientPresentationV2: 'UpdateClientPresentationV2' as const,
    DeleteClientPresentationV2: 'DeleteClientPresentationV2' as const,
    DuplicateClientPresentationV2: 'DuplicateClientPresentationV2' as const,
    AppendBundleToClientPresentationV2: 'AppendBundleToClientPresentationV2' as const
  },
  Fragment: {
    ClientPresentationDesignerV2_DocumentSummaryPage: 'ClientPresentationDesignerV2_DocumentSummaryPage' as const,
    ClientPresentationDesignerV2_PresentationPage: 'ClientPresentationDesignerV2_PresentationPage' as const,
    ClientPresentationDesignerV2_GrowthProfile: 'ClientPresentationDesignerV2_GrowthProfile' as const,
    ClientPresentationDesignerV2_EstateWaterfall: 'ClientPresentationDesignerV2_EstateWaterfall' as const,
    ClientPresentationDesignerV2_EstateWaterfallViz: 'ClientPresentationDesignerV2_EstateWaterfallViz' as const,
    ClientPresentationDesignerV2_WaterfallBundleConfiguration: 'ClientPresentationDesignerV2_WaterfallBundleConfiguration' as const,
    ClientPresentationDesignerV2_ComparedWaterfall_EstateWaterfall: 'ClientPresentationDesignerV2_ComparedWaterfall_EstateWaterfall' as const,
    ClientPresentationDesignerV2_ComparedWaterfall: 'ClientPresentationDesignerV2_ComparedWaterfall' as const,
    ClientPresentationDesignerV2_WaterfallComparisonBundleConfiguration: 'ClientPresentationDesignerV2_WaterfallComparisonBundleConfiguration' as const,
    ClientPresentationDesignerV2_EstateInsightsBundleConfiguration: 'ClientPresentationDesignerV2_EstateInsightsBundleConfiguration' as const,
    ClientPresentationDesignerV2_EntityGraphViewBundleConfiguration: 'ClientPresentationDesignerV2_EntityGraphViewBundleConfiguration' as const,
    ClientPresentationDesignerV2_BeneficiariesBundleConfiguration: 'ClientPresentationDesignerV2_BeneficiariesBundleConfiguration' as const,
    ClientPresentationDesignerV2_Entity: 'ClientPresentationDesignerV2_Entity' as const,
    ClientPresentationDesignerV2_EntitySummaryBundleConfiguration: 'ClientPresentationDesignerV2_EntitySummaryBundleConfiguration' as const,
    ClientPresentationDesignerV2_PresentationCustomPageBundleConfiguration: 'ClientPresentationDesignerV2_PresentationCustomPageBundleConfiguration' as const,
    ClientPresentationDesignerV2_EntitiesOverviewBundleConfigurationEntity: 'ClientPresentationDesignerV2_EntitiesOverviewBundleConfigurationEntity' as const,
    ClientPresentationDesignerV2_EntitiesOverviewBundleConfiguration: 'ClientPresentationDesignerV2_EntitiesOverviewBundleConfiguration' as const,
    ClientPresentationDesignerV2_PresentationBundle: 'ClientPresentationDesignerV2_PresentationBundle' as const,
    ClientPresentationDesignerV2_DividerBundleConfiguration: 'ClientPresentationDesignerV2_DividerBundleConfiguration' as const,
    ClientPresentationDesignerV2_DocumentsReviewedBundleConfiguration: 'ClientPresentationDesignerV2_DocumentsReviewedBundleConfiguration' as const,
    ClientPresentationDesignerV2_ItemCitation: 'ClientPresentationDesignerV2_ItemCitation' as const,
    ClientPresentationDesignerV2_TrustOverviewBundleConfiguration: 'ClientPresentationDesignerV2_TrustOverviewBundleConfiguration' as const,
    ClientPresentationDesignerV2_BusinessOverviewBundleConfiguration: 'ClientPresentationDesignerV2_BusinessOverviewBundleConfiguration' as const,
    ClientPresentationDesignerV2_FamilyOverviewBundleConfiguration: 'ClientPresentationDesignerV2_FamilyOverviewBundleConfiguration' as const,
    ClientPresentationDesignerV2_WillBundleConfiguration: 'ClientPresentationDesignerV2_WillBundleConfiguration' as const,
    ClientPresentationDesignerV2_PowerOfAttorneyBundleConfiguration: 'ClientPresentationDesignerV2_PowerOfAttorneyBundleConfiguration' as const,
    ClientPresentationDesignerV2_HealthcareDirectiveBundleConfiguration: 'ClientPresentationDesignerV2_HealthcareDirectiveBundleConfiguration' as const,
    ClientPresentationDesignerV2_AssetDistributionBundleConfiguration: 'ClientPresentationDesignerV2_AssetDistributionBundleConfiguration' as const,
    ClientPresentationDesignerV2_PlanningOpportunitiesBundleConfiguration: 'ClientPresentationDesignerV2_PlanningOpportunitiesBundleConfiguration' as const,
    ClientPresentationDesignerV2_BalanceSheetBundleConfiguration: 'ClientPresentationDesignerV2_BalanceSheetBundleConfiguration' as const,
    ClientPresentationV2_Configuration_ClientPresentationV2: 'ClientPresentationV2_Configuration_ClientPresentationV2' as const,
    ClientPresentationV2_ClientPresentationV2: 'ClientPresentationV2_ClientPresentationV2' as const,
    ClientPresentationDesignerV2_EstateWaterfallOptions: 'ClientPresentationDesignerV2_EstateWaterfallOptions' as const,
    ClientPresentationDesignerV2_EntityDocumentRelationship: 'ClientPresentationDesignerV2_EntityDocumentRelationship' as const,
    ClientPresentationDesignerV2_EntityOptions: 'ClientPresentationDesignerV2_EntityOptions' as const,
    ClientPresentationDesignerV2_Document: 'ClientPresentationDesignerV2_Document' as const,
    ClientPresentationDesignerV2_HouseholdMetrics: 'ClientPresentationDesignerV2_HouseholdMetrics' as const,
    ClientPresentationDesignerV2_HouseholdAssetsSummary: 'ClientPresentationDesignerV2_HouseholdAssetsSummary' as const,
    ClientPresentationDesignerV2_Household: 'ClientPresentationDesignerV2_Household' as const,
    ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientProfile: 'ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientProfile' as const,
    ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientOrganization: 'ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientOrganization' as const,
    ClientPresentationDesignerV2_Cashflow: 'ClientPresentationDesignerV2_Cashflow' as const,
    ClientPresentationDesignerV2_Liability: 'ClientPresentationDesignerV2_Liability' as const,
    ClientPresentationDesignerV2_WorkflowTracker: 'ClientPresentationDesignerV2_WorkflowTracker' as const,
    ClientPresentationDesignerV2_EstateInsight: 'ClientPresentationDesignerV2_EstateInsight' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ClientPresentationV2_Configuration_ClientPresentationV2FragmentDoc = gql`
    fragment ClientPresentationV2_Configuration_ClientPresentationV2 on ClientPresentationV2 {
  id
  showPageNumbers
  showPageNumbersOnCoverSlide
  pageNumberToStartFrom
  showLegalDisclaimer
  showClientNamesInHeader
}
    `;
export const ClientPresentationDesignerV2_DocumentSummaryPageFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_DocumentSummaryPage on DocumentSummaryPage {
  id
  documentType
  relevantClientProfiles {
    edges {
      node {
        id
        displayName
      }
    }
  }
  summary {
    id
    displayName
    summary
    summaryFormat
    documentv2 {
      id
      name
    }
  }
}
    `;
export const ClientPresentationDesignerV2_BalanceSheetBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_BalanceSheetBundleConfiguration on BalanceSheetBundleConfiguration {
  id
  displayName
  showInEstate
  separateInEstateDirectlyHeld
  separateInEstateTrusts
  showOutOfEstate
  separateOutOfEstateTrusts
  hideSmallValues
  showSummaryMetrics
  showExpandedAssetCategories
  includeDeathBenefitInTotals
  includeExportSlide
  hiddenColumns
}
    `;
export const ClientPresentationDesignerV2_PresentationPageFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_PresentationPage on PresentationPage {
  id
  kind
  customPage {
    id
    pageName
    pageContent
    customPrompt
  }
  coverPage {
    id
    customContent
    displayTitle
    customPrompt
  }
  presentationBundleCoverPage {
    id
    content
  }
  waterfallBundleCoverPage {
    id
    content
  }
  documentSummaryPage {
    id
    ...ClientPresentationDesignerV2_DocumentSummaryPage
  }
  beneficiaryPage {
    id
    beneficiaryID
  }
  diagramPage {
    id
    pageName
    customPrompt
    nodeConfigurations {
      ...Diagram_Node
      semanticGroup
      notes
      entityNodeID
      phase
      xPosition
      yPosition
      width
      height
    }
    edgeDefinitions {
      ...Diagram_Edge
      sourceHandle
      targetHandle
      conditional
    }
    phases {
      bands {
        label
        belowPhaseIndex
      }
    }
  }
  balanceSheetBundleConfiguration {
    ...ClientPresentationDesignerV2_BalanceSheetBundleConfiguration
  }
}
    ${ClientPresentationDesignerV2_DocumentSummaryPageFragmentDoc}
${Diagram_NodeFragmentDoc}
${Diagram_EdgeFragmentDoc}
${ClientPresentationDesignerV2_BalanceSheetBundleConfigurationFragmentDoc}`;
export const ClientPresentationDesignerV2_GrowthProfileFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_GrowthProfile on GrowthProfile {
  id
  displayName
  ...GetWaterfallSummary_GrowthProfile
  ...GrowthProfiles_GrowthProfile
  ...EstateWaterfallAssumptionsSlide_GrowthProfile
}
    ${GetWaterfallSummary_GrowthProfileFragmentDoc}
${GrowthProfiles_GrowthProfileFragmentDoc}
${EstateWaterfallAssumptionsSlide_GrowthProfileFragmentDoc}`;
export const ClientPresentationDesignerV2_EstateWaterfallVizFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_EstateWaterfallViz on EstateWaterfallViz {
  _cacheKey
  materializedInputParams {
    __typename
    firstGrantorDeathYear
    secondGrantorDeathYear
    selectedGrowthProfile {
      ...ClientPresentationDesignerV2_GrowthProfile
    }
  }
  nodes {
    ...EstateWaterfall_Node
  }
  ...GetWaterfallSummary_EstateWaterfallViz
  ...EstateWaterfallAssumptionsSlide_EstateWaterfallViz
  ...EstateWaterfall_EstateWaterfallViz
}
    ${ClientPresentationDesignerV2_GrowthProfileFragmentDoc}
${EstateWaterfall_NodeFragmentDoc}
${GetWaterfallSummary_EstateWaterfallVizFragmentDoc}
${EstateWaterfallAssumptionsSlide_EstateWaterfallVizFragmentDoc}
${EstateWaterfall_EstateWaterfallVizFragmentDoc}`;
export const ClientPresentationDesignerV2_EstateWaterfallFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_EstateWaterfall on EstateWaterfall {
  id
  displayName
  household {
    id
    displayName
  }
  filter {
    id
    includedClients {
      edges {
        node {
          id
        }
      }
    }
    includedEntities {
      edges {
        node {
          id
        }
      }
    }
  }
  visualization: visualizationWithProjections(input: {forceZeroGrowth: true}) {
    _cacheKey
    nodes {
      ...HypotheticalTransfersSummaryQuery_EstateWaterfallVizNode
    }
    loans {
      ...HypotheticalTransfersSummaryQuery_EstateWaterfallLoan
    }
    transferLog {
      ...HypotheticalTransfersSummaryQuery_EstateWaterfallTransfer
    }
    ...EstateWaterfall_EstateWaterfallViz
  }
  visualizationWithProjections {
    ...ClientPresentationDesignerV2_EstateWaterfallViz
  }
  nonHypotheticalVisualizationWithProjections: visualizationWithProjections(
    opts: {runWaterfallAsNonHypothetical: true}
  ) {
    ...ClientPresentationDesignerV2_EstateWaterfallViz
  }
  hypotheticalTransfers {
    edges {
      node {
        ...HypotheticalTransfersSummary_EstateWaterfallHypotheticalTransfer
        ...EstateWaterfall_EstateWaterfallHypotheticalTransfer
      }
    }
  }
  hypotheticalSaleLoans {
    edges {
      node {
        ...HypotheticalTransfersSummary_HypotheticalSaleLoan
      }
    }
  }
  hypotheticalGrats {
    edges {
      node {
        ...HypotheticalTransfersSummary_HypotheticalGrat
      }
    }
  }
  hypotheticalCrts(where: {hasSimulatedCrt: true}) {
    edges {
      node {
        ...HypotheticalTransfersSummary_HypotheticalCrt
      }
    }
  }
  hypotheticalClts(where: {hasSimulatedClt: true}) {
    edges {
      node {
        ...HypotheticalTransfersSummary_HypotheticalClt
      }
    }
  }
  hypotheticalInsurance {
    edges {
      node {
        ...HypotheticalTransfersSummary_HypotheticalInsurance
      }
    }
  }
  ...GetWaterfallSummary_EstateWaterfall
  ...EstateWaterfallDiagramSlide_EstateWaterfall
}
    ${HypotheticalTransfersSummaryQuery_EstateWaterfallVizNodeFragmentDoc}
${HypotheticalTransfersSummaryQuery_EstateWaterfallLoanFragmentDoc}
${HypotheticalTransfersSummaryQuery_EstateWaterfallTransferFragmentDoc}
${EstateWaterfall_EstateWaterfallVizFragmentDoc}
${ClientPresentationDesignerV2_EstateWaterfallVizFragmentDoc}
${HypotheticalTransfersSummary_EstateWaterfallHypotheticalTransferFragmentDoc}
${EstateWaterfall_EstateWaterfallHypotheticalTransferFragmentDoc}
${HypotheticalTransfersSummary_HypotheticalSaleLoanFragmentDoc}
${HypotheticalTransfersSummary_HypotheticalGratFragmentDoc}
${HypotheticalTransfersSummary_HypotheticalCrtFragmentDoc}
${HypotheticalTransfersSummary_HypotheticalCltFragmentDoc}
${HypotheticalTransfersSummary_HypotheticalInsuranceFragmentDoc}
${GetWaterfallSummary_EstateWaterfallFragmentDoc}
${EstateWaterfallDiagramSlide_EstateWaterfallFragmentDoc}`;
export const ClientPresentationDesignerV2_WaterfallBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_WaterfallBundleConfiguration on WaterfallBundleConfiguration {
  id
  displayName
  includeCoverPage
  includeAssumptionsPage
  includeDiagramPage
  includeSummaryPage
  includeSummaryBars
  includeSummaryTiles
  showSummaryTileDetails
  useUpdatedSummaryPage
  includeOverview
  includeBeforeFirstDeath
  includeAfterFirstDeath
  includeAfterSecondDeath
  summaryHideZeroDollarItems
  includeTaxOverviewPage
  firstDeathYear
  secondDeathYear
  growthProfile {
    ...ClientPresentationDesignerV2_GrowthProfile
  }
  estateWaterfall {
    ...ClientPresentationDesignerV2_EstateWaterfall
  }
  estateWaterfallViz: estateWaterfallVizNullable {
    ...ClientPresentationDesignerV2_EstateWaterfallViz
  }
  estateWaterfallVizNonHypothetical: estateWaterfallVizNonHypotheticalNullable {
    ...ClientPresentationDesignerV2_EstateWaterfallViz
  }
}
    ${ClientPresentationDesignerV2_GrowthProfileFragmentDoc}
${ClientPresentationDesignerV2_EstateWaterfallFragmentDoc}
${ClientPresentationDesignerV2_EstateWaterfallVizFragmentDoc}`;
export const ClientPresentationDesignerV2_EntityFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_Entity on Entity {
  id
  ...EntityPresentation_Entity
  ...PresentationViewSource_Entity
}
    ${EntityPresentation_EntityFragmentDoc}
${PresentationViewSource_EntityFragmentDoc}`;
export const ClientPresentationDesignerV2_EntitySummaryBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_EntitySummaryBundleConfiguration on EntitySummaryBundleConfiguration {
  id
  entity {
    id
    ...ClientPresentationDesignerV2_Entity
  }
  includeEntitySummaryPage
  includeDiagramAndNotesPage
  includeBalanceSheetPage
  includeBalanceSheetExportPage
  includeBeneficiariesAndDispositionsPage
  includeInsurancePolicySlides
  deathOrder {
    id
    displayName
  }
  includeEntityNotesOnSummaryPage
}
    ${ClientPresentationDesignerV2_EntityFragmentDoc}`;
export const ClientPresentationDesignerV2_PresentationCustomPageBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_PresentationCustomPageBundleConfiguration on PresentationCustomPageBundleConfiguration {
  id
  pageHeader
  pageSubheader
  includePageHeader
}
    `;
export const ClientPresentationDesignerV2_ComparedWaterfall_EstateWaterfallFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_ComparedWaterfall_EstateWaterfall on EstateWaterfall {
  id
  ...ClientPresentationDesignerV2_EstateWaterfall
  ...EstateWaterfallComparisonTrowser_EstateWaterfall
  visualizationWithProjections {
    ...ClientPresentationDesignerV2_EstateWaterfallViz
    ...EstateWaterfallComparisonTrowser_EstateWaterfallViz
  }
}
    ${ClientPresentationDesignerV2_EstateWaterfallFragmentDoc}
${EstateWaterfallComparisonTrowser_EstateWaterfallFragmentDoc}
${ClientPresentationDesignerV2_EstateWaterfallVizFragmentDoc}
${EstateWaterfallComparisonTrowser_EstateWaterfallVizFragmentDoc}`;
export const ClientPresentationDesignerV2_ComparedWaterfallFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_ComparedWaterfall on ComparedWaterfall {
  id
  displayName
  firstDeathYear
  secondDeathYear
  growthProfile {
    id
  }
  estateWaterfall {
    id
    ...ClientPresentationDesignerV2_ComparedWaterfall_EstateWaterfall
  }
  estateWaterfallViz {
    ...ClientPresentationDesignerV2_EstateWaterfallViz
    ...EstateWaterfallComparisonTrowser_EstateWaterfallViz
  }
}
    ${ClientPresentationDesignerV2_ComparedWaterfall_EstateWaterfallFragmentDoc}
${ClientPresentationDesignerV2_EstateWaterfallVizFragmentDoc}
${EstateWaterfallComparisonTrowser_EstateWaterfallVizFragmentDoc}`;
export const ClientPresentationDesignerV2_WaterfallComparisonBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_WaterfallComparisonBundleConfiguration on WaterfallComparisonBundleConfiguration {
  id
  displayName
  includeAssumptionsPage
  includeCoverPage
  comparedWaterfalls {
    ...ClientPresentationDesignerV2_ComparedWaterfall
  }
}
    ${ClientPresentationDesignerV2_ComparedWaterfallFragmentDoc}`;
export const ClientPresentationDesignerV2_EstateInsightFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_EstateInsight on EstateInsight {
  id
  title
  summary
  consideration
  isCritical
  category
  status
  bucket
  position
}
    `;
export const ClientPresentationDesignerV2_EstateInsightsBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_EstateInsightsBundleConfiguration on EstateInsightsBundleConfiguration {
  id
  includeMissingDocumentsPage
  estateInsights {
    ...ClientPresentationDesignerV2_EstateInsight
  }
}
    ${ClientPresentationDesignerV2_EstateInsightFragmentDoc}`;
export const ClientPresentationDesignerV2_EntityGraphViewBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_EntityGraphViewBundleConfiguration on EntityGraphViewBundleConfiguration {
  id
  displayName
  entityGraphView {
    id
    ...GraphViz_View
  }
}
    ${GraphViz_ViewFragmentDoc}`;
export const ClientPresentationDesignerV2_HouseholdMetricsFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_HouseholdMetrics on HouseholdMetrics {
  totalEstateValue
  inEstateValue
  outOfEstateValue
  outOfEstateCharityValue
  outOfEstateFamilyValue
}
    `;
export const ClientPresentationDesignerV2_EntitiesOverviewBundleConfigurationEntityFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_EntitiesOverviewBundleConfigurationEntity on EntitiesOverviewBundleConfigurationEntity {
  id
  index
  isHidden
  entity {
    id
    ...AllEntitiesSlide_Entity
  }
}
    ${AllEntitiesSlide_EntityFragmentDoc}`;
export const ClientPresentationDesignerV2_EntitiesOverviewBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_EntitiesOverviewBundleConfiguration on EntitiesOverviewBundleConfiguration {
  id
  displayName
  showSummaryMetrics
  household {
    id
  }
  householdMetrics {
    ...ClientPresentationDesignerV2_HouseholdMetrics
  }
  entities {
    edges {
      node {
        ...ClientPresentationDesignerV2_EntitiesOverviewBundleConfigurationEntity
      }
    }
  }
}
    ${ClientPresentationDesignerV2_HouseholdMetricsFragmentDoc}
${ClientPresentationDesignerV2_EntitiesOverviewBundleConfigurationEntityFragmentDoc}`;
export const ClientPresentationDesignerV2_BeneficiariesBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_BeneficiariesBundleConfiguration on BeneficiariesBundleConfiguration {
  id
  displayName
  includeHouseholdOverview
  includeIndividualOverviews
  includeDetailedBreakdownsInIndividualOverviews
  firstDeathYear
  secondDeathYear
  growthProfile {
    ...ClientPresentationDesignerV2_GrowthProfile
  }
  estateWaterfall {
    ...ClientPresentation_BeneficiaryReport_EstateWaterfall
  }
  estateWaterfallBeneficiaryReport {
    ...ClientPresentation_BeneficiaryReport_EstateWaterfallBeneficiaryReport
  }
  householdOverviewProfiles {
    id
    displayName
  }
  householdOverviewOrganizations {
    id
    name
  }
  individualOverviewProfiles {
    id
    displayName
  }
  individualOverviewOrganizations {
    id
    name
  }
}
    ${ClientPresentationDesignerV2_GrowthProfileFragmentDoc}
${ClientPresentation_BeneficiaryReport_EstateWaterfallFragmentDoc}
${ClientPresentation_BeneficiaryReport_EstateWaterfallBeneficiaryReportFragmentDoc}`;
export const ClientPresentationDesignerV2_DividerBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_DividerBundleConfiguration on DividerBundleConfiguration {
  id
  dividerTitle
  customContent
}
    `;
export const ClientPresentationDesignerV2_DocumentsReviewedBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_DocumentsReviewedBundleConfiguration on PresentationDocumentsReviewedBundleConfiguration {
  id
  displayName
  reviewedDocuments {
    edges {
      node {
        id
        documentName
        dateDisplay
        sortOrder
      }
    }
  }
}
    `;
export const ClientPresentationDesignerV2_ItemCitationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_ItemCitation on PresentationItemCitation {
  id
  document {
    id
  }
  fileParagraphs {
    id
    boundingRegions {
      PageNumber
      Polygon {
        x
        y
      }
    }
    file {
      id
      pdfDocument {
        id
      }
    }
  }
}
    `;
export const ClientPresentationDesignerV2_TrustOverviewBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_TrustOverviewBundleConfiguration on PresentationTrustOverviewBundleConfiguration {
  id
  displayName
  itemsPerPage
  trusts {
    edges {
      node {
        id
        displayName
        sortOrder
        trustItems {
          edges {
            node {
              id
              label
              body
              sortOrder
              citations {
                ...ClientPresentationDesignerV2_ItemCitation
              }
            }
          }
        }
      }
    }
  }
}
    ${ClientPresentationDesignerV2_ItemCitationFragmentDoc}`;
export const ClientPresentationDesignerV2_BusinessOverviewBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_BusinessOverviewBundleConfiguration on PresentationBusinessOverviewBundleConfiguration {
  id
  displayName
  itemsPerPage
  businesses {
    edges {
      node {
        id
        displayName
        sortOrder
        businessItems {
          edges {
            node {
              id
              label
              body
              sortOrder
              citations {
                ...ClientPresentationDesignerV2_ItemCitation
              }
            }
          }
        }
      }
    }
  }
}
    ${ClientPresentationDesignerV2_ItemCitationFragmentDoc}`;
export const ClientPresentationDesignerV2_FamilyOverviewBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_FamilyOverviewBundleConfiguration on PresentationFamilyOverviewBundleConfiguration {
  id
  displayName
  members {
    edges {
      node {
        id
        name
        relationship
        description
        sortOrder
        citations {
          ...ClientPresentationDesignerV2_ItemCitation
        }
      }
    }
  }
}
    ${ClientPresentationDesignerV2_ItemCitationFragmentDoc}`;
export const ClientPresentationDesignerV2_WillBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_WillBundleConfiguration on PresentationWillBundleConfiguration {
  id
  displayName
  itemsPerPage
  clients {
    edges {
      node {
        id
        client
        sortOrder
        willItems {
          edges {
            node {
              id
              label
              body
              sortOrder
              citations {
                ...ClientPresentationDesignerV2_ItemCitation
              }
            }
          }
        }
      }
    }
  }
}
    ${ClientPresentationDesignerV2_ItemCitationFragmentDoc}`;
export const ClientPresentationDesignerV2_PowerOfAttorneyBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_PowerOfAttorneyBundleConfiguration on PresentationPowerOfAttorneyBundleConfiguration {
  id
  displayName
  itemsPerPage
  clients {
    edges {
      node {
        id
        client
        sortOrder
        powerOfAttorneyItems {
          edges {
            node {
              id
              label
              body
              sortOrder
              citations {
                ...ClientPresentationDesignerV2_ItemCitation
              }
            }
          }
        }
      }
    }
  }
}
    ${ClientPresentationDesignerV2_ItemCitationFragmentDoc}`;
export const ClientPresentationDesignerV2_HealthcareDirectiveBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_HealthcareDirectiveBundleConfiguration on PresentationHealthcareDirectiveBundleConfiguration {
  id
  displayName
  itemsPerPage
  clients {
    edges {
      node {
        id
        client
        sortOrder
        healthcareDirectiveItems {
          edges {
            node {
              id
              label
              body
              sortOrder
              citations {
                ...ClientPresentationDesignerV2_ItemCitation
              }
            }
          }
        }
      }
    }
  }
}
    ${ClientPresentationDesignerV2_ItemCitationFragmentDoc}`;
export const ClientPresentationDesignerV2_AssetDistributionBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_AssetDistributionBundleConfiguration on PresentationAssetDistributionBundleConfiguration {
  id
  displayName
  itemsPerPage
  deathOrderDisplay
  description
  distributionItems {
    edges {
      node {
        id
        displayName
        sortOrder
        itemDetails {
          edges {
            node {
              id
              label
              body
              sortOrder
              citations {
                ...ClientPresentationDesignerV2_ItemCitation
              }
            }
          }
        }
      }
    }
  }
}
    ${ClientPresentationDesignerV2_ItemCitationFragmentDoc}`;
export const ClientPresentationDesignerV2_PlanningOpportunitiesBundleConfigurationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_PlanningOpportunitiesBundleConfiguration on PresentationPlanningOpportunitiesBundleConfiguration {
  id
  displayName
  items {
    edges {
      node {
        id
        sortOrder
        opportunityLabel
        opportunityBody
        rationaleLabel
        rationaleBody
        nextStepLabel
        nextStepBody
      }
    }
  }
}
    `;
export const ClientPresentationDesignerV2_PresentationBundleFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_PresentationBundle on PresentationBundle {
  id
  index
  kind
  templateNotes
  excludeFromOutput
  pages(orderBy: {field: index, direction: ASC}) {
    edges {
      node {
        ...ClientPresentationDesignerV2_PresentationPage
      }
    }
  }
  waterfallBundleConfiguration {
    ...ClientPresentationDesignerV2_WaterfallBundleConfiguration
  }
  entitySummaryBundleConfiguration {
    ...ClientPresentationDesignerV2_EntitySummaryBundleConfiguration
  }
  customPageBundleConfiguration {
    ...ClientPresentationDesignerV2_PresentationCustomPageBundleConfiguration
  }
  waterfallComparisonBundleConfiguration {
    ...ClientPresentationDesignerV2_WaterfallComparisonBundleConfiguration
  }
  estateInsightsBundleConfiguration {
    ...ClientPresentationDesignerV2_EstateInsightsBundleConfiguration
  }
  entityGraphViewBundleConfiguration {
    ...ClientPresentationDesignerV2_EntityGraphViewBundleConfiguration
  }
  entitiesOverviewBundleConfiguration {
    ...ClientPresentationDesignerV2_EntitiesOverviewBundleConfiguration
  }
  beneficiariesBundleConfiguration {
    ...ClientPresentationDesignerV2_BeneficiariesBundleConfiguration
  }
  dividerBundleConfiguration {
    ...ClientPresentationDesignerV2_DividerBundleConfiguration
  }
  balanceSheetBundleConfiguration {
    ...ClientPresentationDesignerV2_BalanceSheetBundleConfiguration
  }
  documentsReviewedBundleConfiguration {
    ...ClientPresentationDesignerV2_DocumentsReviewedBundleConfiguration
  }
  trustOverviewBundleConfiguration {
    ...ClientPresentationDesignerV2_TrustOverviewBundleConfiguration
  }
  businessOverviewBundleConfiguration {
    ...ClientPresentationDesignerV2_BusinessOverviewBundleConfiguration
  }
  familyOverviewBundleConfiguration {
    ...ClientPresentationDesignerV2_FamilyOverviewBundleConfiguration
  }
  willBundleConfiguration {
    ...ClientPresentationDesignerV2_WillBundleConfiguration
  }
  powerOfAttorneyBundleConfiguration {
    ...ClientPresentationDesignerV2_PowerOfAttorneyBundleConfiguration
  }
  healthcareDirectiveBundleConfiguration {
    ...ClientPresentationDesignerV2_HealthcareDirectiveBundleConfiguration
  }
  assetDistributionBundleConfiguration {
    ...ClientPresentationDesignerV2_AssetDistributionBundleConfiguration
  }
  planningOpportunitiesBundleConfiguration {
    ...ClientPresentationDesignerV2_PlanningOpportunitiesBundleConfiguration
  }
  ...CoverSlide_PresentationBundle
  ...CustomSlide_PresentationBundle
}
    ${ClientPresentationDesignerV2_PresentationPageFragmentDoc}
${ClientPresentationDesignerV2_WaterfallBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_EntitySummaryBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_PresentationCustomPageBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_WaterfallComparisonBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_EstateInsightsBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_EntityGraphViewBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_EntitiesOverviewBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_BeneficiariesBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_DividerBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_BalanceSheetBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_DocumentsReviewedBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_TrustOverviewBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_BusinessOverviewBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_FamilyOverviewBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_WillBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_PowerOfAttorneyBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_HealthcareDirectiveBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_AssetDistributionBundleConfigurationFragmentDoc}
${ClientPresentationDesignerV2_PlanningOpportunitiesBundleConfigurationFragmentDoc}
${CoverSlide_PresentationBundleFragmentDoc}
${CustomSlide_PresentationBundleFragmentDoc}`;
export const ClientPresentationV2_ClientPresentationV2FragmentDoc = gql`
    fragment ClientPresentationV2_ClientPresentationV2 on ClientPresentationV2 {
  id
  name
  ...ClientPresentationV2_Configuration_ClientPresentationV2
  reviewRequirement
  approvals {
    id
    kind
  }
  bundles(orderBy: {field: index, direction: ASC}) {
    edges {
      node {
        ...ClientPresentationDesignerV2_PresentationBundle
      }
    }
  }
}
    ${ClientPresentationV2_Configuration_ClientPresentationV2FragmentDoc}
${ClientPresentationDesignerV2_PresentationBundleFragmentDoc}`;
export const ClientPresentationDesignerV2_EstateWaterfallOptionsFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_EstateWaterfallOptions on EstateWaterfall {
  ...WaterfallOverviewBundleSettingsModal_EstateWaterfall
}
    ${WaterfallOverviewBundleSettingsModal_EstateWaterfallFragmentDoc}`;
export const ClientPresentationDesignerV2_EntityDocumentRelationshipFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_EntityDocumentRelationship on EntityDocumentRelationship {
  id
  document {
    id
    name
    type
    summaries {
      id
      displayName
    }
  }
}
    `;
export const ClientPresentationDesignerV2_EntityOptionsFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_EntityOptions on Entity {
  id
  subtype {
    id
    displayName
  }
  entityDocumentRelationships {
    edges {
      node {
        ...ClientPresentationDesignerV2_EntityDocumentRelationship
      }
    }
  }
  ...PresentationViewSource_Entity
  ...AllEntitiesSlide_Entity
}
    ${ClientPresentationDesignerV2_EntityDocumentRelationshipFragmentDoc}
${PresentationViewSource_EntityFragmentDoc}
${AllEntitiesSlide_EntityFragmentDoc}`;
export const ClientPresentationDesignerV2_HouseholdAssetsSummaryFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_HouseholdAssetsSummary on HouseholdAssetsSummary {
  liquidValue
  liquidPercentage
  inEstateLiquidValue
  inEstateLiquidPercentage
  outOfEstateLiquidValue
  outOfEstateLiquidPercentage
}
    `;
export const ClientPresentationDesignerV2_DocumentFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_Document on Document {
  id
  name
  type
  clientProfile {
    id
  }
  summaries {
    id
    displayName
    sourceDocuments(first: 100) {
      edges {
        node {
          id
          name
        }
      }
    }
    updateUser {
      id
      displayName
    }
    updatedAt
  }
  entityDocumentRelationships {
    edges {
      node {
        id
        entity {
          id
          subtype {
            id
            displayName
          }
        }
        testamentaryEntity {
          id
          displayName
        }
      }
    }
  }
}
    `;
export const ClientPresentationDesignerV2_HouseholdFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_Household on Household {
  id
  displayName
  estateValueMetrics {
    ...ClientPresentationDesignerV2_HouseholdMetrics
  }
  estateTaxScenarios {
    id
    ...EstateTaxScenarios_EstateTaxScenario
  }
  possiblePrimaryClients {
    id
    ...LifetimeExemptionCard_ClientProfile
  }
  subBrand {
    id
  }
  documents @skip(if: $presentationOnly) {
    id
    ...ClientPresentationDesignerV2_Document
  }
  ...EntityMap_Household
}
    ${ClientPresentationDesignerV2_HouseholdMetricsFragmentDoc}
${EstateTaxScenarios_EstateTaxScenarioFragmentDoc}
${LifetimeExemptionCard_ClientProfileFragmentDoc}
${ClientPresentationDesignerV2_DocumentFragmentDoc}
${EntityMap_HouseholdFragmentDoc}`;
export const ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientProfileFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientProfile on ClientProfile {
  id
  ...ProfessionalTeamSlide_ClientProfile
}
    ${ProfessionalTeamSlide_ClientProfileFragmentDoc}`;
export const ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientOrganizationFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientOrganization on ClientOrganization {
  id
  ...ProfessionalTeamSlide_ClientOrganization
}
    ${ProfessionalTeamSlide_ClientOrganizationFragmentDoc}`;
export const ClientPresentationDesignerV2_CashflowFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_Cashflow on Cashflow {
  id
  ...EstateWaterfallAssumptionsSlide_Cashflow
}
    ${EstateWaterfallAssumptionsSlide_CashflowFragmentDoc}`;
export const ClientPresentationDesignerV2_LiabilityFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_Liability on Liability {
  id
  ...EstateWaterfallAssumptionsSlide_Liability
}
    ${EstateWaterfallAssumptionsSlide_LiabilityFragmentDoc}`;
export const ClientPresentationDesignerV2_WorkflowTrackerFragmentDoc = gql`
    fragment ClientPresentationDesignerV2_WorkflowTracker on WorkflowTracker {
  id
  status
  kind
  description
  presentation {
    id
  }
}
    `;
export const UpdateBalanceSheetBundleConfigurationForPresentationDocument = gql`
    mutation UpdateBalanceSheetBundleConfigurationForPresentation($input: AugmentedUpdateBalanceSheetBundleConfigurationInput!) {
  updateBalanceSheetBundleConfiguration(input: $input) {
    ...ClientPresentationDesignerV2_BalanceSheetBundleConfiguration
  }
}
    ${ClientPresentationDesignerV2_BalanceSheetBundleConfigurationFragmentDoc}`;
export type UpdateBalanceSheetBundleConfigurationForPresentationMutationFn = Apollo.MutationFunction<UpdateBalanceSheetBundleConfigurationForPresentationMutation, UpdateBalanceSheetBundleConfigurationForPresentationMutationVariables>;

/**
 * __useUpdateBalanceSheetBundleConfigurationForPresentationMutation__
 *
 * To run a mutation, you first call `useUpdateBalanceSheetBundleConfigurationForPresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBalanceSheetBundleConfigurationForPresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBalanceSheetBundleConfigurationForPresentationMutation, { data, loading, error }] = useUpdateBalanceSheetBundleConfigurationForPresentationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBalanceSheetBundleConfigurationForPresentationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBalanceSheetBundleConfigurationForPresentationMutation, UpdateBalanceSheetBundleConfigurationForPresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBalanceSheetBundleConfigurationForPresentationMutation, UpdateBalanceSheetBundleConfigurationForPresentationMutationVariables>(UpdateBalanceSheetBundleConfigurationForPresentationDocument, options);
      }
export type UpdateBalanceSheetBundleConfigurationForPresentationMutationHookResult = ReturnType<typeof useUpdateBalanceSheetBundleConfigurationForPresentationMutation>;
export type UpdateBalanceSheetBundleConfigurationForPresentationMutationResult = Apollo.MutationResult<UpdateBalanceSheetBundleConfigurationForPresentationMutation>;
export type UpdateBalanceSheetBundleConfigurationForPresentationMutationOptions = Apollo.BaseMutationOptions<UpdateBalanceSheetBundleConfigurationForPresentationMutation, UpdateBalanceSheetBundleConfigurationForPresentationMutationVariables>;
export const ClientPresentationDesignerV2Document = gql`
    query ClientPresentationDesignerV2($presentationId: ID!, $householdId: ID!, $presentationOnly: Boolean!, $entitiesWhere: EntityWhereInput!) {
  clientPresentationV2s(where: {id: $presentationId}) {
    edges {
      node {
        ...ClientPresentationV2_ClientPresentationV2
      }
    }
  }
  households(where: {id: $householdId}) {
    edges {
      node {
        ...ClientPresentationDesignerV2_Household
        ...TenantPresentationConfiguration_Household
      }
    }
  }
  householdAssetsSummary(id: $householdId) {
    ...ClientPresentationDesignerV2_HouseholdAssetsSummary
  }
  estateWaterfalls(where: {hasHouseholdWith: [{id: $householdId}]}) @skip(if: $presentationOnly) {
    edges {
      node {
        ...ClientPresentationDesignerV2_EstateWaterfallOptions
      }
    }
  }
  entities(where: {hasHouseholdWith: [{id: $householdId}]}) {
    edges {
      node {
        ...ClientPresentationDesignerV2_EntityOptions
      }
    }
  }
  balanceSheet(householdID: $householdId, presentationConfiguration: true) {
    ...BalanceSheetTable_BalanceSheet
  }
  professionalTeam: clientProfiles(
    where: {hasProfessionalTeamRoles: true, hasHouseholdWith: [{id: $householdId}]}
  ) {
    edges {
      node {
        ...ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientProfile
      }
    }
  }
  professionalTeamOrganizations: clientOrganizations(
    where: {hasProfessionalTeamRoles: true, hasHouseholdWith: [{id: $householdId}]}
  ) {
    edges {
      node {
        ...ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientOrganization
      }
    }
  }
  viewSourceClientProfiles: clientProfiles(
    where: {hasHouseholdWith: [{id: $householdId}], hasOnboardedIndividualSuggestion: true}
  ) {
    edges {
      node {
        ...PresentationViewSource_ClientProfile
      }
    }
  }
  viewSourceClientOrganizations: clientOrganizations(
    where: {hasHouseholdWith: [{id: $householdId}], hasOnboardedOrganizationSuggestion: true}
  ) {
    edges {
      node {
        ...PresentationViewSource_ClientOrganization
      }
    }
  }
  viewSourceTestamentaryEntities: testamentaryEntities(
    where: {hasHouseholdWith: [{id: $householdId}], hasOnboardingTestamentaryEntitySuggestion: true}
  ) {
    edges {
      node {
        ...PresentationViewSource_TestamentaryEntity
      }
    }
  }
  tenantInformation {
    id
    disclosuresConfiguration {
      ...TenantPresentationConfiguration_TenantDisclaimerConfiguration
    }
  }
  cashflows(where: {hasHouseholdWith: [{id: $householdId}]}) {
    edges {
      node {
        id
        ...ClientPresentationDesignerV2_Cashflow
      }
    }
  }
  liabilities(where: {hasHouseholdWith: [{id: $householdId}]}) {
    edges {
      node {
        id
        ...ClientPresentationDesignerV2_Liability
      }
    }
  }
  assetClasses {
    edges {
      node {
        ...GrowthProfileModal_AssetClass
      }
    }
  }
  estateInsights(where: {hasHouseholdWith: [{id: $householdId}]}) {
    edges {
      node {
        ...ClientPresentationDesignerV2_EstateInsight
      }
    }
  }
  householdMissingDocuments(householdID: $householdId) {
    ...HouseholdMissingDocument
  }
  clientProfiles(
    where: {and: [{hasHouseholdWith: {id: $householdId}}, {or: [{isPrimary: true}, {hasRelationshipsWith: {type: CHILD}}]}]}
  ) {
    edges {
      node {
        ...ClientProfile_MissingDocument
      }
    }
  }
  householdWorkflowTrackerHistory(
    householdID: $householdId
    filter: {statusIn: [STARTED], kinds: [PRESENTATION_TEMPLATE_PROMPT_GENERATION]}
  ) {
    edges {
      node {
        ...ClientPresentationDesignerV2_WorkflowTracker
      }
    }
  }
}
    ${ClientPresentationV2_ClientPresentationV2FragmentDoc}
${ClientPresentationDesignerV2_HouseholdFragmentDoc}
${TenantPresentationConfiguration_HouseholdFragmentDoc}
${ClientPresentationDesignerV2_HouseholdAssetsSummaryFragmentDoc}
${ClientPresentationDesignerV2_EstateWaterfallOptionsFragmentDoc}
${ClientPresentationDesignerV2_EntityOptionsFragmentDoc}
${BalanceSheetTable_BalanceSheetFragmentDoc}
${ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientProfileFragmentDoc}
${ClientPresentationDesignerV2_ProfessionalTeamSlide_ClientOrganizationFragmentDoc}
${PresentationViewSource_ClientProfileFragmentDoc}
${PresentationViewSource_ClientOrganizationFragmentDoc}
${PresentationViewSource_TestamentaryEntityFragmentDoc}
${TenantPresentationConfiguration_TenantDisclaimerConfigurationFragmentDoc}
${ClientPresentationDesignerV2_CashflowFragmentDoc}
${ClientPresentationDesignerV2_LiabilityFragmentDoc}
${GrowthProfileModal_AssetClassFragmentDoc}
${ClientPresentationDesignerV2_EstateInsightFragmentDoc}
${HouseholdMissingDocumentFragmentDoc}
${ClientProfile_MissingDocumentFragmentDoc}
${ClientPresentationDesignerV2_WorkflowTrackerFragmentDoc}`;

/**
 * __useClientPresentationDesignerV2Query__
 *
 * To run a query within a React component, call `useClientPresentationDesignerV2Query` and pass it any options that fit your needs.
 * When your component renders, `useClientPresentationDesignerV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientPresentationDesignerV2Query({
 *   variables: {
 *      presentationId: // value for 'presentationId'
 *      householdId: // value for 'householdId'
 *      presentationOnly: // value for 'presentationOnly'
 *      entitiesWhere: // value for 'entitiesWhere'
 *   },
 * });
 */
export function useClientPresentationDesignerV2Query(baseOptions: Apollo.QueryHookOptions<ClientPresentationDesignerV2Query, ClientPresentationDesignerV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientPresentationDesignerV2Query, ClientPresentationDesignerV2QueryVariables>(ClientPresentationDesignerV2Document, withFetchPolicyContext(options));
      }
export function useClientPresentationDesignerV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientPresentationDesignerV2Query, ClientPresentationDesignerV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientPresentationDesignerV2Query, ClientPresentationDesignerV2QueryVariables>(ClientPresentationDesignerV2Document, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useClientPresentationDesignerV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientPresentationDesignerV2Query, ClientPresentationDesignerV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientPresentationDesignerV2Query, ClientPresentationDesignerV2QueryVariables>(ClientPresentationDesignerV2Document, withFetchPolicyContext(options));
        }
export type ClientPresentationDesignerV2QueryHookResult = ReturnType<typeof useClientPresentationDesignerV2Query>;
export type ClientPresentationDesignerV2LazyQueryHookResult = ReturnType<typeof useClientPresentationDesignerV2LazyQuery>;
export type ClientPresentationDesignerV2SuspenseQueryHookResult = ReturnType<typeof useClientPresentationDesignerV2SuspenseQuery>;
export type ClientPresentationDesignerV2QueryResult = Apollo.QueryResult<ClientPresentationDesignerV2Query, ClientPresentationDesignerV2QueryVariables>;
export const UpdateClientPresentationV2Document = gql`
    mutation UpdateClientPresentationV2($input: AugmentedUpdateClientPresentationV2Input!) {
  updateClientPresentationV2(input: $input) {
    id
  }
}
    `;
export type UpdateClientPresentationV2MutationFn = Apollo.MutationFunction<UpdateClientPresentationV2Mutation, UpdateClientPresentationV2MutationVariables>;

/**
 * __useUpdateClientPresentationV2Mutation__
 *
 * To run a mutation, you first call `useUpdateClientPresentationV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientPresentationV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientPresentationV2Mutation, { data, loading, error }] = useUpdateClientPresentationV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientPresentationV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientPresentationV2Mutation, UpdateClientPresentationV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientPresentationV2Mutation, UpdateClientPresentationV2MutationVariables>(UpdateClientPresentationV2Document, options);
      }
export type UpdateClientPresentationV2MutationHookResult = ReturnType<typeof useUpdateClientPresentationV2Mutation>;
export type UpdateClientPresentationV2MutationResult = Apollo.MutationResult<UpdateClientPresentationV2Mutation>;
export type UpdateClientPresentationV2MutationOptions = Apollo.BaseMutationOptions<UpdateClientPresentationV2Mutation, UpdateClientPresentationV2MutationVariables>;
export const DeleteClientPresentationV2Document = gql`
    mutation DeleteClientPresentationV2($householdId: ID!, $presentationId: ID!) {
  deleteClientPresentationV2(
    clientID: $householdId
    presentationID: $presentationId
  )
}
    `;
export type DeleteClientPresentationV2MutationFn = Apollo.MutationFunction<DeleteClientPresentationV2Mutation, DeleteClientPresentationV2MutationVariables>;

/**
 * __useDeleteClientPresentationV2Mutation__
 *
 * To run a mutation, you first call `useDeleteClientPresentationV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientPresentationV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientPresentationV2Mutation, { data, loading, error }] = useDeleteClientPresentationV2Mutation({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      presentationId: // value for 'presentationId'
 *   },
 * });
 */
export function useDeleteClientPresentationV2Mutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientPresentationV2Mutation, DeleteClientPresentationV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientPresentationV2Mutation, DeleteClientPresentationV2MutationVariables>(DeleteClientPresentationV2Document, options);
      }
export type DeleteClientPresentationV2MutationHookResult = ReturnType<typeof useDeleteClientPresentationV2Mutation>;
export type DeleteClientPresentationV2MutationResult = Apollo.MutationResult<DeleteClientPresentationV2Mutation>;
export type DeleteClientPresentationV2MutationOptions = Apollo.BaseMutationOptions<DeleteClientPresentationV2Mutation, DeleteClientPresentationV2MutationVariables>;
export const DuplicateClientPresentationV2Document = gql`
    mutation DuplicateClientPresentationV2($presentationId: ID!) {
  duplicateClientPresentationV2(presentationID: $presentationId) {
    id
  }
}
    `;
export type DuplicateClientPresentationV2MutationFn = Apollo.MutationFunction<DuplicateClientPresentationV2Mutation, DuplicateClientPresentationV2MutationVariables>;

/**
 * __useDuplicateClientPresentationV2Mutation__
 *
 * To run a mutation, you first call `useDuplicateClientPresentationV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateClientPresentationV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateClientPresentationV2Mutation, { data, loading, error }] = useDuplicateClientPresentationV2Mutation({
 *   variables: {
 *      presentationId: // value for 'presentationId'
 *   },
 * });
 */
export function useDuplicateClientPresentationV2Mutation(baseOptions?: Apollo.MutationHookOptions<DuplicateClientPresentationV2Mutation, DuplicateClientPresentationV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateClientPresentationV2Mutation, DuplicateClientPresentationV2MutationVariables>(DuplicateClientPresentationV2Document, options);
      }
export type DuplicateClientPresentationV2MutationHookResult = ReturnType<typeof useDuplicateClientPresentationV2Mutation>;
export type DuplicateClientPresentationV2MutationResult = Apollo.MutationResult<DuplicateClientPresentationV2Mutation>;
export type DuplicateClientPresentationV2MutationOptions = Apollo.BaseMutationOptions<DuplicateClientPresentationV2Mutation, DuplicateClientPresentationV2MutationVariables>;
export const OtherClientPresentationsForHouseholdDocument = gql`
    query OtherClientPresentationsForHousehold($householdId: ID!) {
  clientPresentationV2s(where: {hasHouseholdWith: [{id: $householdId}]}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useOtherClientPresentationsForHouseholdQuery__
 *
 * To run a query within a React component, call `useOtherClientPresentationsForHouseholdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOtherClientPresentationsForHouseholdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOtherClientPresentationsForHouseholdQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useOtherClientPresentationsForHouseholdQuery(baseOptions: Apollo.QueryHookOptions<OtherClientPresentationsForHouseholdQuery, OtherClientPresentationsForHouseholdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OtherClientPresentationsForHouseholdQuery, OtherClientPresentationsForHouseholdQueryVariables>(OtherClientPresentationsForHouseholdDocument, withFetchPolicyContext(options));
      }
export function useOtherClientPresentationsForHouseholdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OtherClientPresentationsForHouseholdQuery, OtherClientPresentationsForHouseholdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OtherClientPresentationsForHouseholdQuery, OtherClientPresentationsForHouseholdQueryVariables>(OtherClientPresentationsForHouseholdDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useOtherClientPresentationsForHouseholdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OtherClientPresentationsForHouseholdQuery, OtherClientPresentationsForHouseholdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OtherClientPresentationsForHouseholdQuery, OtherClientPresentationsForHouseholdQueryVariables>(OtherClientPresentationsForHouseholdDocument, withFetchPolicyContext(options));
        }
export type OtherClientPresentationsForHouseholdQueryHookResult = ReturnType<typeof useOtherClientPresentationsForHouseholdQuery>;
export type OtherClientPresentationsForHouseholdLazyQueryHookResult = ReturnType<typeof useOtherClientPresentationsForHouseholdLazyQuery>;
export type OtherClientPresentationsForHouseholdSuspenseQueryHookResult = ReturnType<typeof useOtherClientPresentationsForHouseholdSuspenseQuery>;
export type OtherClientPresentationsForHouseholdQueryResult = Apollo.QueryResult<OtherClientPresentationsForHouseholdQuery, OtherClientPresentationsForHouseholdQueryVariables>;
export const AppendBundleToClientPresentationV2Document = gql`
    mutation AppendBundleToClientPresentationV2($input: AugmentedUpdateClientPresentationV2Input!) {
  updateClientPresentationV2(input: $input) {
    id
  }
}
    `;
export type AppendBundleToClientPresentationV2MutationFn = Apollo.MutationFunction<AppendBundleToClientPresentationV2Mutation, AppendBundleToClientPresentationV2MutationVariables>;

/**
 * __useAppendBundleToClientPresentationV2Mutation__
 *
 * To run a mutation, you first call `useAppendBundleToClientPresentationV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendBundleToClientPresentationV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendBundleToClientPresentationV2Mutation, { data, loading, error }] = useAppendBundleToClientPresentationV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppendBundleToClientPresentationV2Mutation(baseOptions?: Apollo.MutationHookOptions<AppendBundleToClientPresentationV2Mutation, AppendBundleToClientPresentationV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppendBundleToClientPresentationV2Mutation, AppendBundleToClientPresentationV2MutationVariables>(AppendBundleToClientPresentationV2Document, options);
      }
export type AppendBundleToClientPresentationV2MutationHookResult = ReturnType<typeof useAppendBundleToClientPresentationV2Mutation>;
export type AppendBundleToClientPresentationV2MutationResult = Apollo.MutationResult<AppendBundleToClientPresentationV2Mutation>;
export type AppendBundleToClientPresentationV2MutationOptions = Apollo.BaseMutationOptions<AppendBundleToClientPresentationV2Mutation, AppendBundleToClientPresentationV2MutationVariables>;